import {AfterViewInit, Component, EventEmitter, OnInit, OnDestroy, Output} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { saveAs } from 'file-saver';
import {
  faAward,
  faBolt,
  faCalendar,
  faClock,
  faDollarSign,
  faDolly,
  faGlobe,
  faInfoCircle,
  faPaperclip,
  faShip,
  faStamp,
  faStar,
  faTag,
  faWind
} from '@fortawesome/free-solid-svg-icons';
import { faMap, faMoneyBillAlt, faStar as faStarEmpty } from '@fortawesome/free-regular-svg-icons';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GreenScoreCalcComponent } from './green-score-calc/green-score-calc.component';
import { CalculatorService } from './calculator.service';
import { map } from 'rxjs/operators';
import { URLS } from '../../environments/environment';
import * as moment from 'moment';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { createNewOrder, InitNewOrder, updateOrder } from '../dashboard/orders/orders.actions';
import { selectNewOrder } from '../dashboard/orders/orders.selectors';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TranslateService } from '@ngx-translate/core';
import { TermsService } from '../services/terms.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CalculationMobileComponent } from './calculation-mobile/calculation-mobile.component';
import { OrdersService } from '../dashboard/orders/orders.service';
import { VehicleService } from './services/vehicle.service';
import { ChangeDetectorRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AcceptTermsMobileComponent } from './accept-terms-mobile/accept-terms-mobile.component';
import { AddDocumentsModalComponent } from './add-documents-modal/add-documents-modal.component';
import {CalculatorConstants, VehicleConstants, ShipmentConstants} from "./calculator.constants";
import Bugsnag from "@bugsnag/js";

import { type } from 'os';
import { style } from '@angular/animations';
import { PasswordMatchValidator, salValid } from '../ff-shared/customValidators';
import { formatNumber } from '@angular/common';
import { Alert } from 'selenium-webdriver';
import {log} from "util";
import { $ } from 'protractor';

@Component({
  selector: 'app-calculator-cars',
  template: ``,
  providers: [MessageService]
})
export class CalculatorCarsComponent implements AfterViewInit, OnInit, OnDestroy {
  @Output() calcInitialized = new EventEmitter<void>();
  uploadUrl = URLS.API + 'files/upload';
  shareUrl = URLS.APIPDF;
  shipmentDetails: FormGroup;
  generalDetails: FormGroup;
  faUpload = faPaperclip;
  faTitle: any = faTag;
  faShip: any = faShip;
  faClock: any = faClock;
  iconsSize = '2x';
  sellingType: any[];
  shipmentType: any[];
  currencies: any[] = [];
  currencies2: any[] = [];
  faDolly: any = faDolly;
  faDollarSign: any = faDollarSign;
  selectedCurrency: any;
  selectedSellingType: any;
  fcaConfig: any;
  exwConfig: any;
  fileTypes: any[];
  exwSelectedCountry: any;
  exwHarborsOptions: any;
  exwSectionsOptions: any;
  faMap: any = faMap;
  faGlobe: any = faGlobe;
  faMoney: any = faMoneyBillAlt;
  faInfo: any = faInfoCircle;
  clearanceOptions: any[];
  faStamp: any = faStamp;
  faCalendar: any = faCalendar;
  vehiclesTypes: { label: string; value: any }[];
  faBolt: any = faBolt;
  //clearanceSelected: any = { label: null, value: { name: null, id: null } };
  equippingOptions: any[];
  pollutionOptions: any[];
  DegreePollution: any[];
  faAward: any = faAward;
  faStar: any = faStar;
  faStarEmpty: any = faStarEmpty;
  faWind: any = faWind;
  harborTax: number;
  filesUploadingForm: FormGroup;
  currentRates: any;
  shipmentTypeSelected: any;
  equipmentLevelSelected: any;
  orderForm: FormGroup;
  twoYearsAgo: any;
  twoYearsMinDate: any;
  maxUsedDate: any;
  settings$: Observable<any>;
  data: any;
  totalShippingPriceIls = 0;
  shipmentPrice = 0;
  harborTaxes: number;
  selectedHarbor: any;
  greenScore: number;
  shipmentMethodSelected: any;
  newOrderState$: Observable<{ inSaving: boolean; saved: boolean; errors: any[] }>;
  showGreenScoreAbove100: boolean = false;
  greenScoreValid: any;
  mode = 'new';
  orderID: string;
  shipmentCompanyExpanse = 0;
  transinsurance: boolean;
  insuranceRate = 0.0065;
  totalInsurance = 0;
  priceWithInsurance: number;
  shipmentOnlyPriceILS: number;
  insuranceDesc: string;
  termsText: string;
  fullDetails: any = {
    vehicle: false,
    shipment: false,
    terms: false,
  };
  imImporter: boolean;
  exwCities: any[];
  selectedExwRate: any;
  exwShipmentMethods: any[];
  exwDischargeHarbors: any;
  exwDischargeHarborSelected: any;
  exwVendorsOptions: any;
  exwShipmentMethodSelected: any;
  exwCitySelected: any;
  harborTaxesForCalculate: number;
  selectedFcaSourceCountry: any;
  fcaSourceHarbors: any;
  selectedFcaSourceHarbor: any;
  fcaDischargeHarbors: any;
  selectedFcaDischargeHarbor: any;
  fcaSelectedShippingMethod: any;
  fcaDeliveryDaysSelected: any;
  fcaVendors: any;
  fcaSelectedVendor: any;
  fcaShipmentMethods: any;
  fcaShipmentMethodSelected: any;
  fcaShipmentPrice: number = 0;
  fcaSelectedCurrency: any;
  fcaLandShipmentPrice: number;
  isMobile: boolean;
  sourceDiscount: boolean;
  order: any;
  updateOrder$: Observable<any>;
  sideVisible: boolean = true;
  commercial: boolean;
  importType: any;
  taxiCommercial: boolean;
  taxiPer: boolean;
  cImp: boolean;
  importP: boolean;
  immigrant: boolean;
  priceCar: any = '';
  carPrice: any = null;
  comImport: boolean = true;
  privateImport: boolean = true;
  nameType: string;
  consumer: any = '';
  salesValue: boolean;
  salPrice: any;
  legitPrice: any;
  //fTax: any;
  finalyTaxPer: any;
  //priceValid: any = '';
  validatorsPrice: any = '';
  EquipLevel: any = '';
  taxCalculation: any = '';
  checked: any = '';
  insTransport: any = '';
  insuranceValue: any = '';
  cif2: any = '';
  taxCalculation2: any = '';
  totalTaxes2: any = '';
  vat2: any = '';
  customs: any = '';
  value2: any = '';
  finalTaxMin: any = '';
  priceChanged: boolean = false;
  transport_ins: boolean;
  personalBroker: boolean;
  click_disabled: boolean;
  no_discount: any = '';
  sourceValue: any = '';
  checkinsurance: any = '';
  formcheck: FormGroup;
  submitted: boolean = false;
  pImporter: boolean;
  DegreePollution2: boolean;
  showCurrencyFirst: boolean;

  /* GENERAL BLOCK */
  /* END BLOCK */

  /* SHIPPMENT BLOCK */
  /* END BLOCK */

  /* VEHICLE BLOCK */
  vehicleForm: FormGroup;
  vehicleConditionOptions: any[];
  vehicleTaxes: any;
  vehiclePrice = 0;
  vehiclePriceILS = 0;
  vehicleCurrency: any = null;
  vehicleLegitPrice: number;
  vehicleCondition: any = { label: null, value: { name: null, id: null } };
  vehicleType: any = { label: null, value: { name: null, id: null, discount: null, label: null, per: null } };
  vehicleAirPollution: any;
  vehicleWeight: boolean;
  weightVehicle: boolean = true;
  weightHigh: boolean;
  finalyTax: boolean;
  selectionType: any = '';
  insurance: any = '';
  consumerVal: boolean;
  high_weight: boolean;
  vehicleLegit: any;
  vehicleLegitPriceOK: boolean;
  vehicleTaxesVal: any = '';
  vehicle: any = '';
  user$: Observable<any>;
  IMPORTER_TYPE: number;

  /* END BLOCK */

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private calculatorService: CalculatorService,
    private _bottomSheet: MatBottomSheet,
    private loaderService: NgxUiLoaderService,
    private deviceService: DeviceDetectorService,
    private ordersService: OrdersService,
    private messageService: MessageService,
    private vehicleService: VehicleService,
    private router: Router,
    private fBuilder: FormBuilder,
    private store: Store<AppState>,
    private termsService: TermsService,
    private translateService: TranslateService) {
    this.insuranceDesc = this.termsService.getInsuranceDisclaimer();
    this.termsText = this.termsService.getTermsText();
  }
  private langSub: any;
  ngAfterViewInit(): void {

  }

  ngOnInit(): void {
    this.langSub = this.translateService.onLangChange.subscribe(() => {
      this.insuranceDesc = this.termsService.getInsuranceDisclaimer();
      this.termsText = this.termsService.getTermsText();
    });
    this.initialize();
  }
  initialize(): void {

    // TODO: requires refactor, there is a lot of code duplication
    this.store.select(state => state['login'].userData).subscribe((res)=>{
      // let roleArr;
      // try{
      //   roleArr = JSON.parse(res.role);
      // }
      // catch (e){
      //   roleArr = res.role;
      // }

      let isCommercial = true;
      // for (let i= 0; i < roleArr.length; i++){
      //   if (roleArr[i] == 'commercial_importer'){
      //     isCommercial = true;
      //   }
      // }
      if (isCommercial){
        // this.IMPORTER_TYPE = IMPORTER.Commercial;
      }
      else{ // personal importer
        // Order cap removed — no longer showing the remaining-entries quota toast.
      }

    });


    this.importType = 2;
    this.taxiCommercial = false;
    this.cImp = true;
    this.importP = true;
    this.immigrant = false;
    this.nameType = '';
    this.salesValue = false;
    this.vehicleWeight = true;
    this.weightHigh = true;
    this.finalyTax = false;
    this.consumerVal = true;
    this.high_weight = true;
    this.transport_ins = false;
    this.personalBroker = false;
    this.click_disabled = false;
    this.no_discount = false;
    this.vehicleLegitPriceOK = true;
    this.pImporter = false;
    this.DegreePollution2 = false;
    this.taxiPer = false;
    this.showCurrencyFirst = true;

    this.isMobile = this.deviceService.isMobile();
    this.store.dispatch(InitNewOrder());
    this.newOrderState$ = this.store.select(selectNewOrder).pipe(map(state => {
      if (state.inSaving) {
        this.loaderService.startLoader('calculator-loader');
      } else {
        this.loaderService.stopLoader('calculator-loader');
      }
      return state;
    }));
    this.mode = this.route.snapshot.queryParams.mode || 'new';
    this.orderID = this.route.snapshot.params.orderID;



    this.settings$ = this.calculatorService.getCalculatorSettings().pipe(map((res: any) => {
      this.fileTypes = res.data.fileTypes;
      this.fcaConfig = res.data.fcaConfig;
      this.shipmentType = res.data.methods;
      this.currencies = res.data.currencies;
      this.pollutionOptions = res.data.vehicleAirPollution;
      this.exwConfig = { countries: res.data.countries.filter(c => c.Harbors.length) };
      this.clearanceOptions = res.data.clearanceTypes.map(ct => {
        return { label: ct.label, value: { name: ct.name, label: ct.label, id: ct.id } };
      });
      this.vehicleConditionOptions = res.data.vehicleConditions.map(condition => {
        return { label: condition.label, value: { name: condition.name, label: condition.label, id: condition.id } };
      });
      this.equippingOptions = res.data.vehicleEquipmentLevels.map(level => {
        return { label: level.rank, value: level.id, discount: level.discount, rank: level.rank };
      });

      this.sellingType = res.data.shipmentTypes.map(st => {
        return { label: st.label, value: st.name.toLowerCase(), id: st.id };
      });
      this.twoYearsAgo = moment().subtract('2', 'years').startOf('month');
      this.twoYearsMinDate = this.twoYearsAgo.toDate();
      this.maxUsedDate = moment().subtract('1', 'months').startOf('month').toDate();

      let cur = this.currencies.slice(0, 4);
      let cur1 = this.currencies.slice(31, 32);
      let cur2 = this.currencies.slice(64, 65);
      let cur3 = this.currencies.slice(129, 130);
      this.currencies2.push(...cur);
      this.currencies2.push(...cur1);
      this.currencies2.push(...cur2);
      this.currencies2.push(...cur3);

      this.formcheck = this.fBuilder.group({
        conditions: [false, Validators.requiredTrue]
      });

      this.orderForm = this._formBuilder.group({
        id: [null],
        terms: ['', [Validators.requiredTrue]],
        importer: this._formBuilder.group({
          name: [''],
          phone: [''],
          email: [''],
          imImporter: [false]
        }),
        vehicle: this._formBuilder.group({
          vin: [''],
          details: ['']
        }),
        supplier: this._formBuilder.group({
          name: [''],
          phone: [''],
          email: [''],
        })
      });
      this.filesUploadingForm = this._formBuilder.group({
        ownerID: [''],
        lading: [''],
        vehicleLicence: [''],
        shippingInvoice: [''],
        moneyTransfer: [''],
        moneyTransferShipment: [''],
        advancePayment: [''],
        moneyTransferTaxRefund: [''],
        importApproval: [''],
        COC: [''],
        DataCard: [''],
        Eur1: [''],
        vehicleContract: [''],
        TinyImporter: [''],
        supplierInvoice: ['']
      });

      this.generalDetails = this._formBuilder.group({
        shipmentTitle: [''],
        importerType: ['', Validators.required]
      });
      this.shipmentDetails = this._formBuilder.group({
        //shipmentTitle: [''],
        sellingType: [null, [Validators.required]],
        shipmentPrice: this._formBuilder.group({
          value: [null, Validators.required],
          currency: [null, Validators.required],
          exwShipmentMethod: [null]
        }),
        shipmentType: [null, Validators.required],
        shipmentHarbor: [null],
        shipmentCountry: [null],
        shipmentSection: [null],
        harborTax: [null],
        shipmentCompanyExpanse: [0],
        totalShipmentPriceILS: [null, [Validators.required]],
        exwRate: [null],
        exwCity: [null],
        shipmentTypeExw: [null],
        exwShipmentDays: [null],
        fcaRate: [null],
        fcaVendor: [null],
        fcaShipmentMethod: [null]
      });
      this.vehicleForm = this._formBuilder.group({
        vehiclePrice: this._formBuilder.group({
          buyingPrice: this._formBuilder.group({
            value: [null, [Validators.required]],
            currency: ['', [Validators.required]]
          }),
          legitPrice: this._formBuilder.group({
            value: ['', [Validators.required]],
            currency: ['ils']
          }),
        }),
        registerDateOverSeas: [''],
        clearanceType: [null,],
        vehicleCondition: [null, [Validators.required]],
        vehicleType: ['', [Validators.required]],
        vehicleAirPollution: [null, [Validators.required]],
        vehicleEquipLevel: ['', [Validators.required]],
        originDiscount: [''],
        greenScore: [''],
        vehicleOnRoadDate: [''],
        sourceDiscount: [null, [Validators.required]],
        greenScoreValid: [null, [Validators.required]],
        approve12: [false],
        insurance: [false, [Validators.required]],
        vehicleWeightLevel: [null],
      },
      );

      enum IMPORTER {
        Personal = 1,
        Commercial = 2
      }
      this.IMPORTER_TYPE = IMPORTER.Commercial;
      // this.store.select(state => state['login'].userData).subscribe((res)=>{
      //   var roleArr;
      //   try{
      //      roleArr = JSON.parse(res.role);
      //   }
      //   catch(e){
      //      roleArr = res.role;
      //   }
      //
      //   var isCommercial = false;
      //   for(var i=0;i<roleArr.length;i++){
      //     if(roleArr[i] == 'commercial_importer'){
      //       isCommercial = true;
      //     }
      //   }
      //   if(isCommercial){
      //     this.IMPORTER_TYPE = IMPORTER.Commercial;
      //   }
      //   else{
      //     this.IMPORTER_TYPE = IMPORTER.Personal;
      //   }
      //
      //   if(this.IMPORTER_TYPE == IMPORTER.Commercial){
      //     this.parImporter();
      //   }else{
      //     this.persImporter();
      //   }
      //   this.generalDetails.get('importerType').patchValue(this.IMPORTER_TYPE);
      // })

      // if (this.orderID && this.mode === 'edit') {
      //   this.calculatorService.getOrder(this.orderID).subscribe((response: any) => {
      //     this.order = response.data;
      //     if (!this.order) {
      //       this.mode = 'new';
      //       return;
      //     }
      //     if (this.order.status !== 'New' && this.order.status !== 'Draft' && this.order.status !== 'Temp') {
      //       this.router.navigate(['/account/orders', this.order.id], { queryParams: { mode: 'view' } });
      //     }
      //     /**
      //      * Shipment Details
      //      */
      //     const sellingType = this.sellingType.find(st => st.id === this.order.shipment.ShipmentType?.id);
      //     this.shipmentDetails.get('sellingType').patchValue(sellingType?.id);
      //     this.shipmentDetails.get('shipmentTitle')?.patchValue(this.order.title);
      //     this.selectedSellingTypeChanged({ value: sellingType?.value });
      //     switch (sellingType?.value) {
      //       case 'exw':
      //         const { ExwRate: exw } = this.order.shipment;
      //         this.exwSelectedCountry = exw.Country;
      //         this.shipmentDetails.get('exwRate').patchValue(exw.id);
      //         this.shipmentDetails.get('exwCity').patchValue(exw.city);
      //         const exwCountry = res.data.countries.find(c => c.id === exw.CountryId);
      //         this.exwCities = res.data.countries.find(c => c.id === exw.Country.id).Cities;
      //         this.exwHarborsOptions = exwCountry.Harbors;
      //         this.exwDischargeHarborSelected = exw.dHarbor;
      //         this.selectedHarbor = exw.Harbor;
      //
      //         this.exwDischargeHarbors = exwCountry.Cities.find(c => c.city === exw.city).options.find(o => o.harborId === exw.HarborId).dOptions;
      //
      //
      //         this.exwVendorsOptions = exwCountry.Harbors.find(r => r.id === exw.HarborId).ExwRates;
      //
      //         this.shipmentDetails.get('exwShipmentDays').patchValue(exw.deliveryDays);
      //         this.exwShipmentMethods = exw.ExwShipmentMethods;
      //         this.exwShipmentMethodSelected = this.exwShipmentMethods.find(met => met.shipmentMethod === this.order.shipment.shipmentMethod);
      //         this.shipmentDetails.get('shipmentPrice').get('exwShipmentMethod').patchValue(this.exwShipmentMethodSelected.id);
      //         // this.shipmentMethodSelected = this.order.shipment.shipmentMethod;
      //         this.exwShipmentMethodChange(this.exwShipmentMethodSelected);
      //         break;
      //       case 'fca':
      //         const { FcaRate: fca } = this.order.shipment;
      //         const fcaCountry = res.data.fcaConfig.find(c => c.countryId === fca.CountryId);
      //
      //         this.fcaSourceCountryChanged(fcaCountry);
      //         const sourceHarbor = fcaCountry.sourceHarbors.find(sh => sh.id === fca.HarborId);
      //         this.fcaHarborChanged(sourceHarbor);
      //         let dischargeHarbor = sourceHarbor.dischargeHarbors.find(dh => dh.label === fca.dischargeHarbor.label);
      //         this.selectedFcaDischargeHarborChanged(dischargeHarbor);
      //         let selectedVendor = dischargeHarbor.vendors.find(v => v.deliveryDays === fca.deliveryDays);
      //         this.fcaVendorSelectedChange(selectedVendor);
      //         this.shipmentDetails.get('fcaVendor').patchValue(selectedVendor.deliveryDays);
      //         let selectedShippingMethod = selectedVendor.shipmentMethods.find(sm => sm.shipmentMethod === this.order.shipment?.shipmentMethod);
      //         this.fcaShipmentMethodChanged(selectedShippingMethod);
      //         this.shipmentDetails.get('fcaShipmentMethod').patchValue(selectedShippingMethod.id);
      //         this.shipmentPriceChanged({ value: this.order.shipment.shipmentPrice });
      //         this.shipmentDetails.get('shipmentPrice').get('value').setValue(this.order.shipment.shipmentPrice);
      //         const currentCur = this.currencies.find(c => c.name.toLowerCase() === this.order.shipment.Currency.name.toLowerCase());
      //         this.currencyChanged(currentCur);
      //
      //         break;
      //       default:
      //         this.shipmentDetails.get('shipmentPrice').get('value').patchValue(this.order.shipment.shipmentPrice);
      //
      //         const currencyCurrency = this.currencies.find(c => c.name === this.order.shipment?.Currency?.name.toLowerCase());
      //         this.shipmentPriceChanged({ value: this.order.shipment?.shipmentPrice });
      //         this.currencyChanged(currencyCurrency);
      //         const shipmentMethod = this.shipmentType.find(st => st.id === this.order.shipment?.ShipmentMethods?.id);
      //         this.shipmentDetails.get('shipmentType').patchValue(shipmentMethod?.id);
      //         //debugger
      //         this.shipmentMethodChanged(shipmentMethod);
      //
      //         break;
      //     }
      //
      //     this.orderForm.get('id').patchValue(this.order.id);
      //     this.orderForm.get('terms').patchValue(false);
      //     this.orderForm.get('importer')?.get('name')?.patchValue(this.order?.importer?.name || '');
      //     this.orderForm.get('importer')?.get('email')?.patchValue(this.order?.importer?.email || '');
      //     this.orderForm.get('importer')?.get('phone')?.patchValue(this.order?.importer?.phone || '');
      //     this.orderForm.get('supplier')?.get('name')?.patchValue(this.order?.supplier?.name || '');
      //     this.orderForm.get('supplier')?.get('phone')?.patchValue(this.order?.supplier?.phone || '');
      //     this.orderForm.get('supplier')?.get('email')?.patchValue(this.order?.supplier?.email || '');
      //     debugger
      //     this.orderForm.get('vehicle')?.get('details')?.patchValue(this.order?.shipment?.vehicles[0]?.vehicleTypeDetails || '');
      //     this.orderForm.get('vehicle')?.get('vin')?.patchValue(this.order?.shipment?.vehicles[0]?.vehicleVin || '');
      //     console.log(this.order);
      //     // TODO: how to determine if the user is the importer??
      //     // this.orderForm.get('importer').get('imImporter').setValue(false);
      //     // Set order name
      //     this.generalDetails.get('shipmentTitle')?.patchValue(this.order.title);
      //     // Set order importer type
      //     this.generalDetails.get('importerType').patchValue(this.order.importerType);
      //     /**
      //      * Vehicle Details
      //      */
      //     const vehicle = this.order.shipment.vehicles[0];
      //
      //     // Set clearance and init subform
      //     const clearance = this.clearanceOptions.find(co => co.value.id === vehicle?.ClearanceType?.id);
      //     this.vehicleForm.get('clearanceType').setValue(clearance?.value?.id);
      //     this.clearanceChanged(clearance?.value?.id);
      //     this.clearanceInit(clearance);
      //     // Set vehicle weight level
      //     // vehicle.vehicleWeightLevel = VehicleConstants.WEIGHT_LEVEL_AVG;
      //     this.vehicleForm.get('vehicleWeightLevel').patchValue(vehicle.vehicleWeightLevel);
      //     this.vehicleWeightInit(vehicle.vehicleWeightLevel);
      //     // Set vehicle price
      //     this.vehicleForm.get('vehiclePrice').get('buyingPrice').get('value').patchValue(vehicle.price);
      //     this.vehicleForm.get('vehiclePrice').get('legitPrice').get('value').patchValue(vehicle.legitPrice);
      //
      //     const vehicleCurrentCurrency = this.currencies.find(c => c.name === vehicle?.Currency?.name.toLowerCase());
      //     this.vehicleForm.get('vehiclePrice').get('buyingPrice').get('currency').patchValue(vehicle.price);
      //     this.vehiclePriceChanged({ value: vehicle.price });
      //
      //     this.vehicleCurrencyChanged(vehicleCurrentCurrency);
      //     if (this.order.clearanceType === 2) {
      //       this.vehicleLegitPriceChanged(vehicle.legitPrice || 0);
      //     }
      //     // Set vehicleType
      //     const vehicleType = this.vehiclesTypes.find(vt => vt.value?.id === vehicle?.vehicleType);
      //     this.vehicleForm.get('vehicleType').patchValue(vehicleType);
      //     this.vehicleTypeChanged(vehicleType);
      //     // Set vehicle condition
      //     let vehicleCondition = this.vehicleConditionOptions.find(vc => vc.value.id === vehicle?.vehicleCondition);
      //     this.vehicleForm.get('vehicleCondition').patchValue(vehicle.vehicleCondition);
      //     this.vehicleConditionChanged(vehicleCondition);
      //     // Set air pollution
      //     const airPollution = this.pollutionOptions.find(po => po.id === vehicle.vehicleAirPollution);
      //     this.vehicleForm.get('vehicleAirPollution').patchValue(vehicle.vehicleAirPollution);
      //     this.vehicleAirPollutionChanged(airPollution);
      //     // Set source discount
      //     this.vehicleForm.get('sourceDiscount').patchValue(vehicle.sourceDiscount);
      //     this.sourceDiscountChange({ value: vehicle.sourceDiscount });
      //     // Set green score
      //     this.vehicleForm.get('greenScore').patchValue(vehicle.vehicleGreenScore);
      //     // Set transport insurance
      //     this.vehicleForm.get('insurance').patchValue((vehicle.insurance)?true:false);
      //     this.transportInsurance({ value: vehicle.insurance });
      //
      //     if (vehicle.VehicleEquipmentLevel) {
      //       this.equipmentRatingChanged(vehicle.VehicleEquipmentLevel);
      //       this.vehicleForm.get('vehicleEquipLevel').patchValue(vehicle.VehicleEquipmentLevel.id);
      //     }
      //
      //   });
      // } else {

        // const approve = this.dialog.open(AcceptTermsMobileComponent, {});
        // approve.afterClosed().subscribe(res => {
        //   if (!res || !res.approve) {
        //     this.router.navigate(['/account']);
        //   } else {
            this.vehiclePriceILS = 0;
            this.vehicleForm.get('vehiclePrice').get('buyingPrice').get('value').patchValue(null);
            this.vehicleForm.get('insurance').patchValue(false);
            // this.vehiclePrice = 0;
            let taxesObj = { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS };
            let vehicleObj = { ...this.vehicleForm.value, vehiclePriceILS: this.vehiclePriceILS };
            let generalObj = this.generalDetails.value;
            vehicleObj.vehicleCondition = this.vehicleCondition.label;
            delete vehicleObj.greenScoreValid;
            delete taxesObj.effectiveBuyTax;
            delete taxesObj.luxTax;
            delete taxesObj.bnu;
            delete taxesObj.buyingTaxPercentage;
            delete taxesObj.buyTax;
            delete taxesObj.customClearance;
            delete taxesObj.customFee;
            delete taxesObj.luxTaxPercentage;
            delete taxesObj.registerFee;
            delete taxesObj.totalLuxPrice;
            delete taxesObj.totalTaxes;
            delete taxesObj.value;
            delete taxesObj.vat;
            delete taxesObj.finalTax;
            delete taxesObj.reductions;
            delete generalObj.importerType;
            this.orderForm.get('terms').setValue(false);
            // api expect number for vehicleType
            if (typeof vehicleObj.vehicleType !== 'number') {
              vehicleObj.vehicleType = vehicleObj.vehicleType?.value?.id;
            }

            this.ordersService.createNewOrder({
              general: generalObj,
              vehicle: vehicleObj,
              shipment: this.shipmentDetails.value,
              order: { ...this.orderForm.value, terms: true },
              taxes: taxesObj,
              mode: 'new',
              status: 'Temp'
            }).subscribe((res: any) => {
              this.order =
                res.data;
            });
          // }
          this.vehicleForm.get('insurance').patchValue('');

        // });

            // Bugsnag.notify(new Error('Init Calculator'))

      // }
      this.data = res.data;
      return res.data;
    }));

    this.settings$.subscribe((res: any) => {
      this.calcInitialized.emit();
    });
  }

  get vForm(): any {
    return this.vehicleForm.controls;
  }
  updateVehicleTypes(types: any[]) {
    this.vehiclesTypes = types.map(vt => {
      return { label: vt.label, value: { name: vt.name, label: vt.label, discount: vt.discount, per: vt.taxPercentage, id: vt.id } };
    });
    if (this.vehicleType.label) {
      this.vehicleType = this.vehiclesTypes.find(t => t.label === this.vehicleType.label);
    }
    this.calculate();
  }

  currencyChanged($event: any): void {
    this.selectedCurrency = $event;
    this.shipmentDetails.get('shipmentPrice').get('currency').setValue($event?.id);
    this.calculate();
  }

  currencyAdd() {
    this.showCurrencyFirst = false;
  }

  currencyAddFirst() {
    this.showCurrencyFirst = true;
  }

  selectedSellingTypeChanged($event: any): void {
    console.log($event);
    this.shipmentDetails.get('shipmentType').setValue(null);
    this.shipmentDetails.get('shipmentPrice').get('currency').setValue(null);
    this.shipmentDetails.get('shipmentPrice').get('value').setValue(null);
    this.selectedHarbor = null;
    this.shipmentCompanyExpanse = 0;
    this.selectedSellingType = null;


    /**
     * Fca Reset
     */
    this.shipmentDetails.get('fcaShipmentMethod').setValue(null);
    this.shipmentDetails.get('fcaVendor').setValue(null);
    this.fcaDischargeHarbors = null;
    this.fcaShipmentMethodSelected = null;
    this.fcaSelectedCurrency = null;
    this.fcaSelectedShippingMethod = null;
    this.fcaVendors = null;
    this.fcaShipmentMethods = null;
    this.selectedFcaSourceCountry = null;
    this.selectedFcaSourceHarbor = null;
    this.selectedFcaDischargeHarbor = null;
    this.fcaSourceHarbors = null;


    this.selectedCurrency = null;
    this.shipmentMethodSelected = null;
    this.shipmentTypeSelected = null;
    this.shipmentPrice = 0;
    this.totalShippingPriceIls = 0;
    this.shipmentOnlyPriceILS = 0;

    /**
     * Exw Reset
     */
    this.shipmentDetails.get('shipmentPrice').get('exwShipmentMethod').setValue(null);
    this.shipmentDetails.get('exwCity').setValue(null);
    this.shipmentDetails.get('exwRate').setValue(null);
    this.exwDischargeHarborSelected = null;
    this.exwSelectedCountry = null;
    this.exwCitySelected = null;
    this.exwVendorsOptions = null;


    if ($event) {
      this.selectedSellingType = $event.value;
    }
    this.fullDetails.shipment = false;
  }
  persImporter() {
    this.importType = 1;
    this.clearanceChanged(1);
    this.commercialImports();
    this.pImporter = true;
    this.selectionType = 'private';
    this.privateImport = true;
  }

  parImporter() {
    this.importType = 2;
    this.clearanceChanged(2);
    this.importCom();
    this.pImporter = true;
    this.selectionType = 'commercial';
    this.comImport = true;
  }

  collectors() {
    if ( this.vehicleType?.value?.id ) {
      this.vehicleType.value.id = null;
    }
    this.commercial = true;
    this.cImp = false;
    this.carPrice = null;
    this.privateImport = false;
    // this.comImport = false;
    // this.vehicleLegitPriceOK = true;
  }

  newcomer() {
    if ( this.vehicleType?.value?.id ) {
      this.vehicleType.value.id = null;
    }
    this.commercial = false;
    this.cImp = false;
    this.immigrant = true;
    this.carPrice = null;
    this.privateImport = false;
  }

  commercialImports() {
    this.showCurrencyFirst = true;
    this.vehicleForm.get('sourceDiscount').setValidators([Validators.required]);
    this.taxiPer = false;
    this.cImp = true;
    this.privateImport = true;
    this.carPrice = null;
  }

  taxi_com() {
    this.comImport = false;
    this.high_weight = true;
    this.taxiPer = false;
    this.taxiCommercial = true;
    this.importP = false;
    this.priceCar = "";
    //this.EquipLevel = "";
    this.personalBroker = false;
    this.vehicleWeight = false;
    // this.vehicleLegitPriceOK = true;
    this.calculate();

  }
  taxi_per() {
    this.taxiCommercial = false;
    this.taxiPer = true;
    this.high_weight = true;
    this.importP = false;
    this.priceCar = "";
    this.comImport = false;
    this.personalBroker = false;
    this.vehicleWeight = false;
    this.calculate();

  }
  personal_broker() {
    this.fullDetails.vehicle =
      this.selectionType != null &&
      this.vehiclePriceILS &&
      this.vehicleCurrency &&
      this.vehicleCondition?.value?.id != null &&
      (!!this.vehicleAirPollution || !!this.greenScore);

    this.vehicleWeight = false;
    this.priceCar = "";
    this.taxiPer = false;
    this.personalBroker = true;
    this.comImport = false;
    this.importP = false;
    this.taxiCommercial = false;
    this.high_weight = true;
    this.no_discount = false;
    this.click_disabled = false;
    this.calculate();
  }
  importCom() {
    this.lowWeight();
    this.priceCar = "";
    this.importP = true;
    this.comImport = true;
    this.high_weight = true;
    this.personalBroker = false;
    this.vehicleWeight = true;
    this.no_discount = false;
    this.click_disabled = false;
    this.consumerVal = true;
  }
  lowWeight() {
    this.vehicleForm.get('vehicleWeightLevel').setValue(VehicleConstants.WEIGHT_LEVEL_LOW);
    this.priceCar = "";
    this.high_weight = true;
    this.consumerVal = true;
    this.vehicleWeight = true;
    this.weightHigh = true;
    this.finalyTax = false;
    this.weightVehicle = true;
    this.getBuyingTax();
    this.calculate();
  }

  avgWeight() {
    this.vehicleForm.get('vehicleWeightLevel').setValue(VehicleConstants.WEIGHT_LEVEL_AVG);
    this.priceCar = "";
    this.sourceDiscountChange(false);
    this.high_weight = false;
    this.consumerVal = false;
    this.vehicleWeight = false;
    this.weightHigh = true;
    this.finalyTax = false;
    this.weightVehicle = false;
    this.DegreePollution2 = false;
    this.vehicleForm.get('vehicleAirPollution').setValue(null);
    this.getBuyingTax();
    this.calculate();
  }
  highWeight() {
    this.vehicleForm.get('vehicleWeightLevel').setValue(VehicleConstants.WEIGHT_LEVEL_HIGH);
    this.priceCar = "";
    this.sourceDiscountChange(false);
    this.high_weight = false;
    this.consumerVal = false;
    this.vehicleWeight = false;
    this.weightHigh = false;
    this.finalyTax = true;
    this.weightVehicle = false;
    this.DegreePollution2 = false;
    this.vehicleForm.get('vehicleAirPollution').setValue(null);
    this.getBuyingTax();
    this.calculate();
  }

  CheckboxonChanged() {
    if (this.formcheck.invalid) {
      this.transport_ins = true;
      this.submitted = true;
    }
    else {
      this.transport_ins = false;
      this.submitted = false;
    }

  }

  exwSelectedCountryChanged($event: any): void {
    if (!$event) {
      this.exwSelectedCountry = null;
      this.exwCities = null;
      return;
    }
    this.exwSelectedCountry = $event;
    this.exwCities = $event.Cities;
    this.selectedHarbor = null;
    this.shipmentDetails.get('shipmentHarbor').setValue(null);
    this.shipmentDetails.get('shipmentSection').setValue(null);

  }

  exwHarborChanged($event: any): void {
    if (!$event) {
      this.selectedHarbor = null;
      this.exwDischargeHarbors = null;
      return;
    }
    this.selectedHarbor = $event;
    this.exwDischargeHarbors = $event.dOptions;
  }

  fcaHarborChanged($event: any): void {
    this.selectedFcaSourceHarbor = $event;
    this.fcaDischargeHarbors = $event.dischargeHarbors;
  }

  resetVehicle() {
    this.equipmentLevelSelected = null;
    this.vehiclePriceILS = null;
    // this.vehicleCondition = { label: null, value: { name: null, id: null } };
    // this.vehicleType = { label: null, value: { name: null, id: null, discount: null, label: null, per: null } };
    this.vehicleAirPollution = null;
    // this.importerType = this.vehicle.clearanceType;
    // this.vehicleForm.get('vehicleEquipLevel').setValue(null);
    // this.vehicleForm.get('vehicleCondition').setValue(null);
    // this.vehicleForm.get('vehicleAirPollution').setValue(null);
  }

  clearanceChanged($event: any): void {
    this.resetVehicle();
    this.selectionType = $event;
    if (!this.selectionType) {
      return;
    }

    if (this.selectionType == 'commercialTaxi') {
      this.vehicleForm.get('vehicleEquipLevel').setValidators([Validators.required]);
    } else {
      this.vehicleForm.get('vehicleEquipLevel').setValidators(null);
    }
    if (this.selectionType == 'collectors') {
      this.vehicleForm.get('sourceDiscount').setValue('');
    }
    if (this.selectionType == 'immigrate') {
      this.vehicleForm.get('sourceDiscount').setValue(false);
    }
    if (this.selectionType == 'commercial') {
      this.vehicleForm.get('vehiclePrice').get('legitPrice').get('value').setValidators([Validators.required]);
      this.vehicleForm.get('vehiclePrice').get('legitPrice').get('currency').setValidators([Validators.required]);
    } else {
      this.vehicleForm.get('vehiclePrice').get('legitPrice').get('value').setValidators(null);
      this.vehicleForm.get('vehiclePrice').get('legitPrice').get('currency').setValidators(null);
    }
    // TODO: set car
    this.calculate();
  }

  vehicleWeightInit(level?: number) {
    switch (level) {
      case VehicleConstants.WEIGHT_LEVEL_LOW:
        this.lowWeight();
        break;
      case VehicleConstants.WEIGHT_LEVEL_AVG:
        this.avgWeight();
        break;
      case VehicleConstants.WEIGHT_LEVEL_HIGH:
        this.highWeight();
        break;
      default: break;
    }
  }

  clearanceInit(clearance) {
    // Personal Import
    if ( this.order?.importerType == 1 ) {
      this.importType = 1;
      this.privateImport = true;
      this.selectionType = 'private';
      this.pImporter = true;
      switch (clearance?.value?.id) {
        case 1: // personal import
        default:
          this.commercialImports()
          break
        case 5: // collectors
          this.collectors()
          break
        case 6: // newcomer
          this.newcomer();
          break
      }
    }
    // Parallel Import
    if ( this.order.importerType == 2 ) {
      this.importType = 2;
      this.pImporter = true;
      this.comImport = true;
      this.selectionType = 'commercial';
      switch (clearance?.value?.id) {
        case 1: // personal import broker
          this.personal_broker()
          break
        case 2: // commercial import
        default:
          this.importCom()
          break
        case 3: // private taxi
          this.taxi_per();
          break
        case 4: // commercial taxi
          this.taxi_com();
          break
      }
    }
  }

  greenScoreValidChange($event: any) {
    this.greenScoreValid = !!$event.value;
    this.vehicleForm.get('greenScoreValid').patchValue(this.greenScoreValid);
    this.calculate();
  }


  equipmentRatingChanged($event: any) {
    this.equipmentLevelSelected = $event;
    this.calculate();
  }

  openGreenScoreCalc() {
    const greenScoreModal: MatDialogRef<any> = this.dialog.open(GreenScoreCalcComponent, {
      width: '60vw',
      data: this.pollutionOptions
    });

    greenScoreModal.afterClosed().subscribe(res => {
      if (res) {
        this.vForm['greenScore'].setValue(res.score);
        this.vForm['vehicleAirPollution'].setValue(res.pollution);
      }

    });
  }

  vehiclePriceChanged($event: any) {
    if (this.vehicleWeight && this.importType == 2) {
      this.transport_ins = false;
      this.vehicleForm.get('insurance').patchValue("");
      if (this.priceChanged) {
        this.vehicleForm.get('sourceDiscount').patchValue(null);
      }
    }

    this.vehicleTaxesVal = this.vehicleTaxes.value;
    if ($event) {
      this.vehicleLegitPriceOK = true;
      if (typeof $event === 'number') {
        this.vehiclePrice = $event;
      } else {
        this.vehiclePrice = $event?.value;
      }
    }
    else {
      this.vehicleLegitPriceOK = false;
      //buyingPrice.value = null;
    }
    this.calculate();
  }

  myUploader($event: any, type: string) {
    this.filesUploadingForm.get(type).setValue($event.files[0]);

  }

  resTitleChanged($event) {
    this.generalDetails.get('shipmentTitle')?.patchValue($event.target.value);
    // debugger;
    // this.fullDetails.get('shipmentTitle')?.patchValue($event.target.value);
  }

  get generalForm() {
    return this.generalDetails.controls;
  }

  get shipmentFormValues() {
    return this.shipmentDetails.value;
  }

  get vehicleDetailsValues() {
    return this.vehicleForm.value;
  }

  hasVehicleDetails() {
    for (const i in this.vehicleForm.value) {
      if (i === 'buyingPrice' || i === 'legitPrice') {
        if (this.vehicleForm.value[i].currency || this.vehicleForm.value[i].value) {
          return true;
        }
      }
    }
  }
  /**
   * Return 0.5% percent for vehicle all currencies, except ILS
   */
  getVehicleCurrencyPercent(): number {
    return VehicleConstants.PERCENT_CURRENCY;
  }
  /**
   * Return 4.5% percent for shipment all currencies, except ILS
   */
  getShipmentCurrencyPercent(): number {
    return ShipmentConstants.PERCENT_CURRENCY;
  }

  getVehiclePrice() {
    /**
     * Add 0.5% for all currencies except ILS for vehicle.
     * +1 need to convert 0.005 to 1.005. To add this percent in formula.
     * Get percent from price - * 0.005. Add percent to price - * 1.005
     */
    let vehicleCurrencyPercent = this.getVehicleCurrencyPercent() + 1;

    this.vehiclePriceILS = this.vehiclePrice;
    if (!this.vehicleCurrency) {
      return;
    }
    if (this.vehicleCurrency.name.toUpperCase() !== 'ILS') {
      this.vehiclePriceILS = this.vehiclePrice * (this.vehicleCurrency.value) * vehicleCurrencyPercent;
    }
  }

  getShipmentPrice() {
    let shipmentPrice = 0;
    /**
     * Add 4.5% for all currencies except ILS for shipment.
     * +1 need to convert 0.045 to 1.045. To add this percent in formula.
     * Get percent from price - * 0.045. Add percent to price - * 1.045
     */
    let shipmentCurrencyPercent = this.getShipmentCurrencyPercent() + 1;

    if (this.selectedSellingType === 'fca') {
      // debugger;
      if (this.fcaShipmentPrice === null) {
        this.fcaShipmentPrice = 0;
      }
      if (!this.selectedCurrency || !this.fcaShipmentMethodSelected) {
        return;
      }
      this.fcaSelectedCurrency = this.currencies.find(c => c.name.toUpperCase() === this.fcaShipmentMethodSelected.CurrenciesList.name);
      if (this.fcaShipmentMethodSelected.CurrenciesList.name.toUpperCase() !== 'ILS') {
        this.shipmentOnlyPriceILS = this.fcaShipmentPrice * this.fcaSelectedCurrency.value * shipmentCurrencyPercent;
      } else {
        this.shipmentOnlyPriceILS = this.fcaShipmentPrice;
      }
      // this.fcaLandShipmentPrice =  this.fcaShipmentPrice;
      // this.shipmentPrice = this.fcaShipmentPrice;
      if (this.shipmentMethodSelected && this.vehiclePriceILS) {
        if (this.shipmentMethodSelected.isPer) {
          this.harborTaxesForCalculate = (this.vehiclePriceILS * this.shipmentMethodSelected.methodPrice);
        } else {
          this.harborTaxesForCalculate = this.shipmentMethodSelected.methodPrice;
        }
      }

      if (this.selectedCurrency.name.toUpperCase() !== 'ILS') {
        this.shipmentOnlyPriceILS += this.selectedCurrency.value * this.shipmentPrice * shipmentCurrencyPercent;
      } else {
        this.shipmentOnlyPriceILS += this.shipmentPrice;
      }
      shipmentPrice = this.shipmentOnlyPriceILS;

    } else if (this.selectedSellingType === 'exw') {
      const currency = this.currencies.find(c => c.name.toUpperCase() === this.exwShipmentMethodSelected.CurrenciesList.name);
      this.selectedCurrency = currency;
      this.shipmentPrice = this.exwShipmentMethodSelected.price;

      if (this.exwShipmentMethodSelected.CurrenciesList.name.toUpperCase() !== 'ILS') {
        this.shipmentOnlyPriceILS = this.exwShipmentMethodSelected.price * currency.value * shipmentCurrencyPercent;
      } else {
        this.shipmentOnlyPriceILS = this.shipmentPrice;
      }

      if (this.shipmentMethodSelected && this.vehiclePriceILS) {
        if (this.shipmentMethodSelected.isPer) {
          this.harborTaxesForCalculate = (this.vehiclePriceILS * this.shipmentMethodSelected.methodPrice);
        } else {
          this.harborTaxesForCalculate = this.shipmentMethodSelected.methodPrice;
        }
      }
      shipmentPrice = this.shipmentOnlyPriceILS;
    } else {
      shipmentPrice = this.shipmentPrice;
      if (!this.selectedCurrency || !this.shipmentMethodSelected) {
        return;
      }
      if (this.selectedCurrency.name.toUpperCase() !== 'ILS') {
        shipmentPrice = shipmentPrice * this.selectedCurrency.value * shipmentCurrencyPercent;
      }
      this.shipmentOnlyPriceILS = shipmentPrice;
      if (this.shipmentMethodSelected && this.vehiclePriceILS) {
        if (this.shipmentMethodSelected.isPer) {
          this.harborTaxesForCalculate = (this.vehiclePriceILS * this.shipmentMethodSelected.methodPrice);
        } else {
          this.harborTaxesForCalculate = this.shipmentMethodSelected.methodPrice;
        }
      }
    }
    if (this.shipmentMethodSelected) {
      shipmentPrice += this.shipmentMethodSelected.shipmentCompanyCosts;
    }
    this.shipmentDetails.get('totalShipmentPriceILS').patchValue(shipmentPrice);
    this.shipmentDetails.get('shipmentPrice').get('value').patchValue(this.shipmentPrice);
    this.shipmentDetails.get('shipmentPrice').get('currency').patchValue(this.selectedCurrency.id);
    this.shipmentDetails.get('shipmentCompanyExpanse').setValue(this.shipmentMethodSelected.shipmentCompanyCosts);
    this.totalShippingPriceIls = shipmentPrice;

    return this.shipmentDetails.get('totalShipmentPriceILS').value;

  }

  shipmentTypeChanged($event: any) {
    this.shipmentTypeSelected = $event.value !== undefined ? $event.value : parseInt($event.target.value);
    this.calculate();
  }

  getHarborTaxes() {
    if (!this.vehiclePriceILS) {
      this.harborTaxesForCalculate = 0;
    } else {
      this.harborTaxesForCalculate = (this.vehiclePriceILS + this.totalShippingPriceIls) * 0.006;
      if (this.shipmentMethodSelected && this.shipmentMethodSelected.methodName === 'roro') {
        this.harborTaxesForCalculate = 1450;
      }
    }

  }

  getCustomClearancePrice() {

    // return Math.ceil(((this.vehiclePriceILS || 0) + (this.totalShippingPriceIls || 0)) * 1.006);
    // const CustomClear=(this.vehiclePriceILS || 0) + (this.harborTaxesForCalculate || 0) + (this.totalShippingPriceIls || 0) + (this.insurance ? this.totalInsurance : 0);
    return (this.vehiclePriceILS || 0) + (this.harborTaxesForCalculate || 0) + (this.totalShippingPriceIls || 0) + (this.transinsurance ? this.totalInsurance : 0);

    //     this.insTransport
  }

  getCustomClearance(multiplier = 0.07) {
    // || this.customs
    if (this.vehicleDetailsValues.sourceDiscount) {
      return 0;
    }
    if (this.selectionType == 'immigrate') {
      multiplier = 0.5;
    }
    if (this.transinsurance) {

      return ((this.getCustomClearancePrice() + this.insTransport) * multiplier);
    }
    else {
      return (this.getCustomClearancePrice() * multiplier);
    }
  }

  /**
   * Get Buying Tax
   *
   * Result 1: if vehicleWeight is set then return
   * percent 83% from getCustomClearancePrice() + getCustomClearance()
   *
   * Result 2: if weightHigh is set then return
   * percent 72% from getCustomClearancePrice() + getCustomClearance()
   *
   * Result 3: if vehicleWeight and weightHigh is empty then return 0
   *
   * @param baseTax
   * @param addTax
   */
  getBuyingTax(baseTax: number = 0.83, addTax: number = 0) {

    if (this.vehicleWeight) {
      return (this.getCustomClearancePrice() + this.getCustomClearance()) * (baseTax + addTax);
    }
    else if (this.weightHigh) {
      return (this.getCustomClearancePrice() + this.getCustomClearance()) * (0.72);
    }
    else {
      this.vehicleTaxes.finalTax = 0;
      //this.finalyTax = true;
      return 0;
    }
  }

  getVat() {
    return (this.getBuyingTax() + this.getCustomClearancePrice() + this.getCustomClearance()) * VehicleConstants.PERCENT_VAT;
  }

  getSupplierProfit() {
    return (this.getVat() + this.getBuyingTax() + this.getCustomClearancePrice() + this.getCustomClearance()) * .20;
  }

  getVehicleValue() {
    return (this.getVat() + this.getBuyingTax() + this.getCustomClearancePrice() + this.getCustomClearance() + this.getSupplierProfit());
  }

  getMonthPeriod() {
    // if (!this.vehicleCondition.label || this.vehicleCondition.value?.id === 1) {
    //   return {
    //     month: 0,
    //     days: 0,
    //     year: 0,
    //   };
    // }
    if (this.vehicleDetailsValues.vehicleOnRoadDate) {
      return {
        month: moment().diff(moment(this.vehicleDetailsValues.vehicleOnRoadDate), 'month'),
        days: moment().diff(moment(this.vehicleDetailsValues.vehicleOnRoadDate), 'day'),
        year: moment().diff(moment(this.vehicleDetailsValues.vehicleOnRoadDate), 'year'),
      };
    } else {
      return {
        month: 0,
        days: 0,
        year: 0,
      };
    }
  }

  getWaste() {
    if (this.getMonthPeriod()) {
      const { month } = this.getMonthPeriod();
      return month * 0.0125;
    }
    return null;
  }

  getVehicleValueAfterWaste() {
    if (this.getWaste() && this.getVehicleValue()) {
      const waste = this.getWaste();
      return (1 - waste) * this.getVehicleValue();
    }
    return this.getVehicleValue();
  }

  getLuxuryTax() {
    const vehicleValueForLuxuryTax = this.getVehicleValueAfterWaste() - 300000;
    if (vehicleValueForLuxuryTax <= 0) {
      return 0;
    }
    return vehicleValueForLuxuryTax / this.getVehicleValueAfterWaste() * (20 / 100);
  }

  /**
   * Initialize selection type and type name
   * Use in CALCULATE
   */
  initSelectionType() {
    if (this.importType == 1) {
      if (this.cImp) {
        this.selectionType = 'private';
        this.nameType = 'יבוא אישי';
      }
      else if (this.commercial) {
        this.selectionType = 'collectors';
        this.nameType = 'רכב אספנות';
      }
      else if (this.immigrant) {
        this.selectionType = 'immigrate';
        this.nameType = 'עולה חדש';
      }
    }
    else if (this.importType == 2) {
      if (this.personalBroker) {
        this.selectionType = 'perBroker';
        this.nameType = 'מתווך ביבוא אישי';
      }
      else if (this.importP) {
        this.selectionType = 'commercial';
        this.nameType = 'יבוא מסחרי';
      }
      else if (this.taxiCommercial) {
        this.selectionType = 'commercialTaxi';
        this.nameType = 'מונית מסחרי';
      }
      else if (!this.taxiCommercial) {
        this.selectionType = 'privateTaxi';
        this.nameType = 'מונית פרטי';
      }
    }
  }

  /**
   * Get bool value for full detail vehicle by shipment type CFR/EXW/FCA/null
   * Use in CALCULATE
   */
  isVehicleFullDetails(sellingType: string) {
    let isDetails = false;
    if (sellingType) {
      switch (sellingType) {
        case 'cfr':
          isDetails =
          // this.sourceDiscount !== undefined &&
          this.selectionType != null &&
          this.vehiclePriceILS &&
          this.vehicleCurrency &&
          this.vehicleCondition?.value?.id != null &&
          (!!this.vehicleAirPollution || !!this.greenScore);
          break;
        case 'exw':
          isDetails =
            // this.sourceDiscount !== undefined &&
            this.selectionType != null &&
            //this.clearanceSelected?.value?.id != null &&
            this.vehiclePriceILS &&
            this.vehicleCurrency &&
            this.vehicleCondition.value.id != null &&
            (!!this.vehicleAirPollution || !!this.greenScore);
          break;
        case 'fca':
          isDetails =
            // this.sourceDiscount !== undefined &&
            this.selectionType != null &&
            //this.clearanceSelected?.value?.id != null &&
            this.vehiclePriceILS &&
            this.vehicleCurrency &&
            this.vehicleCondition.value.id != null &&
            (!!this.vehicleAirPollution || !!this.greenScore);
          break;
        default:
          isDetails =
            // this.sourceDiscount !== undefined &&
            this.selectionType != null &&
            //this.clearanceSelected?.value?.id != null &&
            this.vehiclePriceILS &&
            this.vehicleCurrency &&
            this.vehicleCondition.value.id != null &&
            (!!this.vehicleAirPollution || !!this.greenScore);
          break;
      }
    }
    return isDetails;
  }
  /**
   * Get bool value for full detail shipment by shipment type CFR/EXW/FCA/null
   * Use in CALCULATE
   */
  isShipmentFullDetails(sellingType: string) {
    let isDetails = false;
    if (sellingType) {
      switch (sellingType) {
        case 'cfr':
          isDetails = !!(this.selectedSellingType && this.shipmentMethodSelected && this.shipmentPrice !== undefined && !!this.selectedCurrency);
          break;
        case 'exw':
          isDetails = !!(this.selectedSellingType && this.shipmentMethodSelected && this.shipmentPrice !== undefined);
          break;
        case 'fca':
          isDetails = !!(this.selectedSellingType && this.shipmentMethodSelected && this.shipmentPrice !== undefined);
          break;
        default:
          isDetails = !!(this.selectedSellingType && this.exwShipmentMethodSelected && this.shipmentPrice);
          break;
      }
    }
    return isDetails;
  }

  calculate(wi: boolean = false) { //, car: any) {
    /**
     * Init price this.vehiclePriceILS
     */
    this.getVehiclePrice();
    /**
     * Init this.shipmentOnlyPriceILS, this.harborTaxesForCalculate
     */
    this.getShipmentPrice();
    /**
     * Init this.harborTaxesForCalculate
     */
    this.getHarborTaxes();

    const vehicleType = this.vehicleType?.value;
    /**
     * Car age in months, 0 if new
     */
    const { month } = this.getMonthPeriod();

    /**
     * Get bool values for full detail vehicle/shipment by CFR/EXW/FCA/null
     */
    this.fullDetails.vehicle = this.isVehicleFullDetails(this.selectedSellingType);
    this.fullDetails.shipment = this.isShipmentFullDetails(this.selectedSellingType);

    /**
     * Define basic object that returned as calculate result
     */
    this.vehicleTaxes = {};

    /**
     * Luxury tax. Diffrent in commercial/personal import.
     * In personal import. Tou have a complex formula.
     *
     * In commercial formula is :
     * [(Value of sale user insert- 300,000)/value of sale)*0.2
     */
    const minForTax = 300000;

    /**
     * Define main formula values
     * D - Customs Duty (if Any), in ILS
     * CIF - Import price for tax, in ILS
     * t - Maximum luxury tax, 20%.
     * T - Regular Buying tax without luxury tax, in ILS (83% less deductions)
     * VAT - Value added tax, 17%
     * margin - Normal margin, 20%.
     * age - Car age in months, 0 if new
     */
    const c = {
      D: this.getCustomClearance(),
      CIF: this.getCustomClearancePrice(),
      t: 0.2,
      T: this.getBuyingTax(),
      VAT: VehicleConstants.PERCENT_VAT,
      margin: (20 / 100),
      age: month
    };

    const greenScore = this.vehicleDetailsValues.greenScore || 0;
    let totalTaxDiscount = 0;
    const buyingTaxPercentage = 83;
    let reduceDis = 0;
    let greenDiscount = 0;
    let bnu = 0;
    if (vehicleType) {
      reduceDis = vehicleType.discount;
    }
    c.T = this.getBuyingTax(); //@todo probably it is unnecessary double execution
    this.showGreenScoreAbove100 = false;
    if (this.vehicleAirPollution) {
      if (this.vehicleAirPollution.rank >= 3) {
        reduceDis = 0;
      }
      if (this.vehicleAirPollution.rank == 2) {
        if (this.vehicleType) {
          if (this.vehicleType.value?.name == VehicleConstants.PLUGIN_TYPE_NAME && this.vehicleWeight || this.vehicleType.value?.name == VehicleConstants.PLUGIN_TYPE_NAME && this.personalBroker) {
            this.fullDetails.vehicle = this.fullDetails.vehicle && this.greenScoreValid !== undefined;
            if (this.greenScoreValid) //invalid
            {
              reduceDis = 0;
            }
            this.showGreenScoreAbove100 = true;
          }
        }

      }
      else {
        this.showGreenScoreAbove100 = false;
      }
      //Daniel
      // if (!!this.greenScore && this.greenScore == 100)
      // {
      //   reduceDis = 0;
      // }
      greenDiscount = this.vehicleAirPollution.discount;
    }

    let luxTax = 0;
    /**
     * Discounts
     * green - Pollution discount
     * type - Drive discount
     * equip -
     */
    const reductions: any = {
      green: greenDiscount,
      type: reduceDis
    };
    if (this.equipmentLevelSelected) {
      reductions.equip = this.equipmentLevelSelected.discount;
    }

    totalTaxDiscount = reductions.type + greenDiscount + (reductions.equip || 0);
    let taxForCalculate = c.T;
    if (this.selectionType = 'commercialTaxi') {
      taxForCalculate -= totalTaxDiscount;
    }
    //  vehicleType = electric && parallel OR vehicleType = electric && personal
    //@todo rename DegreePollutions2 => isDegreePollutions, DegreePollution => DegreePollutionList
    if (
      this.vehicleType?.value?.name == VehicleConstants.ELECTRIC_TYPE_NAME && this.high_weight && this.importType == 2
      || this.vehicleType?.value?.name == VehicleConstants.ELECTRIC_TYPE_NAME && this.importType == 1
    ) {
      this.DegreePollution2 = true;
      const size = 1;
      this.DegreePollution = this.pollutionOptions.slice(0, size);
      //for electric set air pollution as level 1
      this.vehicleForm.get('vehicleAirPollution').setValue(1);
      const airPollution = this.pollutionOptions.find(po => po.id === 1);
      this.vehicleAirPollution = airPollution;
    }
    else {
      this.DegreePollution2 = false;
    }
    let totalTaxes = 0;
    const p0 = ((c.CIF + taxForCalculate + c.D) * (1 + c.VAT)) / ((1 - c.margin) * (1 - 0.0125 * c.age));
    // tslint:disable-next-line:one-variable-per-declaration
    let totalLuxPrice = 0, luxTaxPercentage = 0, effectiveBuyTaxPercent = 0, effectiveBuyTax = 0, vat = 0, vehiclePrice = 0,
      vehicleCurrency = 'ils';
    // tslint:disable-next-line:one-variable-per-declaration
    const customFee = 1755;
    const registerFee = 91; //previously 86
    const harborFee = this.harborTaxes;
    this.vehicleTaxes.shipmentCosts =
      this.shipmentOnlyPriceILS +
      (this.shipmentMethodSelected ? this.shipmentCompanyExpanse + this.shipmentMethodSelected.emptyPrice : 0)
      ;

    this.showCurrencyFirst = true;

    /**
     * Init this.selectionType, this.nameType  properties for Personal/Parallel imports
     */
    this.initSelectionType();

    switch (this.selectionType) {
      // PERSONAL IMPORTER
      // Personal Imports
      case 'private':
        if (p0 > minForTax) {
          luxTax = (
            p0 + (c.t * (c.CIF + c.D)) * (1 + c.VAT) +
            Math.sqrt(
              (Math.pow(p0 + c.t * (c.CIF + c.D) * (1 + c.VAT), 2)) -
              (4 * minForTax * c.t * (c.CIF + c.D) * (1 + c.VAT))
            )
          ) / 2;

          if (luxTax > minForTax) {
            luxTaxPercentage = (luxTax - minForTax) / luxTax * 0.2;
          } else {
            luxTaxPercentage = 0;
          }
          totalLuxPrice = (c.CIF + c.D) * luxTaxPercentage;
        }
        this.cif2 = c.CIF;
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        effectiveBuyTaxPercent = ((totalLuxPrice + c.T) / c.CIF) * 100;
        if (vehicleType) {
          bnu = ((c.CIF + c.D) * (luxTaxPercentage + (vehicleType.per / 100)));
          if (bnu < 0 || !bnu) {
            bnu = 0;
          }
        }
        c.D = this.getCustomClearance();
        if (this.transinsurance) {
          this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
          this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
          this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
          c.CIF = this.insuranceValue;
          c.D = this.getCustomClearance();
          c.T = (c.CIF + this.getCustomClearance()) * 0.83;
          this.finalyTaxPer = 0.83;
          this.taxCalculation = (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount + totalLuxPrice;
          vat = (c.CIF + c.D + this.taxCalculation) * VehicleConstants.PERCENT_VAT;
          this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        else {
          this.finalyTaxPer = 0.83;
          this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.taxCalculation2 = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.insuranceValue = this.getCustomClearancePrice();
          vat = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          c.T = (this.cif2 + this.getCustomClearance()) * 0.83;
          this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        if (this.vehicleType?.value?.name == VehicleConstants.ELECTRIC_TYPE_NAME) {
          this.finalTaxMin = this.percentCustomPricesByType();
          // Update finalTaxMin if deduct more that percent
          this.updatePurhasedTax();

          this.taxCalculation2 = this.finalTaxMin;
          if (this.transinsurance) {
            vat = (c.CIF + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          } else {
            this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
            vat = (this.cif2 + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          }
          //totalTaxes = vat + (this.taxCalculation == 0 ? this.taxCalculation2 : this.taxCalculation) + registerFee + c.D;
        }
        else if (this.vehicleType?.value?.name == VehicleConstants.PLUGIN_TYPE_NAME) {
          this.finalTaxMin = this.percentCustomPricesByType();
          //this.finalTaxMin = (c.T * (this.vehicleType?.value?.per / 100));
          // Update finalTaxMin if deduct more that percent
          this.updatePurhasedTax();

          this.taxCalculation2 = this.finalTaxMin;
          if (this.transinsurance) {
            vat = (c.CIF + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          } else {
            this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
            vat = (this.cif2 + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          }
          //totalTaxes = vat + (this.taxCalculation == 0 ? this.taxCalculation2 : this.taxCalculation) + registerFee + c.D;
        }
        else {
          this.finalTaxMin = 0;
        }
        this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
        const v3 = (totalTaxes + (this.vehiclePriceILS + this.vehicleTaxes.shipmentCosts || 0) + customFee);
        const newVat = (c.CIF + c.D + effectiveBuyTax) * VehicleConstants.PERCENT_VAT;
        const totalTax = (effectiveBuyTax) + newVat;
        c.CIF = this.cif2;
        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          // discountPer: pollution?.per,
          buyTaxNoDiscount: c.T + totalTaxDiscount,
          buyingTaxPercentage,
          totalLuxPrice,
          effectiveBuyTaxPercent,
          effectiveBuyTax,
          priceNoLux: p0,
          priceWithLux: luxTax,
          finalTax: this.taxCalculation > this.finalTaxMin ? this.taxCalculation : this.finalTaxMin,
          luxTaxPercentage,
          luxTax: totalLuxPrice,
          vat,
          buyTax: c.T,
          totalTaxes,
          customClearance: this.getCustomClearance(),
          value: totalTaxes + this.vehiclePriceILS + (this.vehicleTaxes.shipmentCosts || 0) + customFee + this.value2,
          registerFee,
          customFee,
          reductions,
          shipmentMethod: this.shipmentMethodSelected,
          bnu
        };

        break;
      // Collectors Vehicle
      case 'collectors':
        this.fullDetails.vehicle = this.vehicleCurrency && this.vehiclePriceILS && this.shipmentOnlyPriceILS >= 0 && this.shipmentMethodSelected;
        vehiclePrice = this.vehiclePriceILS;
        vehicleCurrency = this.vehicleCurrency;
        luxTaxPercentage = 0;
        this.cif2 = c.CIF;
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        effectiveBuyTax = c.T + vat + c.D;
        c.T = c.CIF * 0.72;
        if (c.T < 0) {
          c.T = 0;
        }
        c.D = this.getCustomClearance();
        if (this.transinsurance) {
          this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
          this.totalTaxes2 = this.vat2 + registerFee + c.D;
          this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
          c.CIF = this.insuranceValue;
          c.D = this.getCustomClearance();
          c.T = (c.CIF + this.getCustomClearance()) * 0.72;
          vat = (c.CIF + c.D + c.T) * VehicleConstants.PERCENT_VAT;
          //this.value2 = (c.CIF + vat + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + registerFee + c.D) * 0.008;
          var val2 = (this.vehicleTaxesVal - registerFee - customFee) *0.008
          this.value2 = (val2 < 250)?250: val2;
          totalTaxes = vat + registerFee + c.D + c.T;
        }
        else {
          this.insuranceValue = this.getCustomClearancePrice();
          c.T = (this.cif2 + this.getCustomClearance()) * 0.72;
          vat = (this.cif2 + c.D + c.T) * VehicleConstants.PERCENT_VAT;
          this.vat2 = (this.cif2 + c.D + c.T) * VehicleConstants.PERCENT_VAT;
          totalTaxes = vat + registerFee + c.D + c.T;
        }
        this.totalTaxes2 = this.vat2 + registerFee + c.D;
        c.CIF = this.cif2;
        reductions.type = 0;
        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          luxTaxPercentage,
          totalLuxPrice: 0,
          buyingTaxPercentage: 72,
          vat,
          bnu: 0,
          totalTaxes,
          finalTax: 0,
          customClearance: this.getCustomClearance(),
          registerFee,
          customFee,
          shipmentOnly: this.shipmentOnlyPriceILS,
          buyTax: c.T,
          shipmentMethod: this.shipmentMethodSelected,
          value: totalTaxes
            + this.vehiclePriceILS + customFee + (this.vehicleTaxes.shipmentCosts) + this.value2,
        };
        break;
      // Newcomer
      case 'immigrate':
        vehiclePrice = this.vehiclePriceILS;
        vehicleCurrency = this.vehicleCurrency;
        this.fullDetails.vehicle = this.vehicleCurrency && this.vehiclePriceILS && this.shipmentOnlyPriceILS >= 0 && this.shipmentMethodSelected;
        this.cif2 = c.CIF;
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        c.T = c.CIF * 0.72;
        if (c.T < 0) {
          c.T = 0;
        }
        c.D = c.CIF * 0.5;
        if (this.transinsurance) {
          this.totalTaxes2 = this.vat2 + registerFee + c.D;
          this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
          this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
          c.CIF = this.insuranceValue;
          c.T = (c.CIF + this.getCustomClearance()) * 0.72;
          c.D = c.CIF * 0.5;
          vat = (c.CIF + c.D) * VehicleConstants.PERCENT_VAT;
          this.value2 = (c.CIF + vat + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + registerFee + c.D) * 0.008;
          totalTaxes = vat + registerFee + c.D;
        }
        else {
          this.insuranceValue = this.getCustomClearancePrice();
          vat = (this.cif2 + c.D) * VehicleConstants.PERCENT_VAT;
          c.T = (this.cif2 + this.getCustomClearance()) * 0.72;
          this.vat2 = (this.cif2 + c.D) * VehicleConstants.PERCENT_VAT;
          totalTaxes = vat + registerFee + c.D;
          c.D = this.getCustomClearance();
        }
        this.totalTaxes2 = this.vat2 + registerFee + c.D;
        c.CIF = this.cif2;
        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          luxTaxPercentage: 0,
          buyingTaxPercentage: 0,
          totalLuxPrice: 0,
          vat,
          totalTaxes,
          registerFee,
          customFee,
          shipmentOnly: this.shipmentOnlyPriceILS,
          buyTax: 0,
          finalTax: 0,
          customClearance: this.getCustomClearance(),
          bnu: 0,
          shipmentMethod: this.shipmentMethodSelected,
          value: totalTaxes
            + this.vehiclePriceILS + customFee + (this.vehicleTaxes.shipmentCosts) + this.value2,
        };
        break;
      // PARALLEL IMPORTER
      // Personal Broker
      case 'perBroker':
        if (p0 > minForTax) {
          luxTax = (
            p0 + (c.t * (c.CIF + c.D)) * (1 + c.VAT) +
            Math.sqrt(
              (Math.pow(p0 + c.t * (c.CIF + c.D) * (1 + c.VAT), 2)) -
              (4 * minForTax * c.t * (c.CIF + c.D) * (1 + c.VAT))
            )
          ) / 2;

          if (luxTax > minForTax) {
            luxTaxPercentage = (luxTax - minForTax) / luxTax * 0.2;
          } else {
            luxTaxPercentage = 0;
          }
          totalLuxPrice = (c.CIF + c.D) * luxTaxPercentage;
        }
        this.cif2 = c.CIF;
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        effectiveBuyTaxPercent = ((totalLuxPrice + c.T) / c.CIF) * 100;
        if (vehicleType) {
          bnu = ((c.CIF + c.D) * (luxTaxPercentage + (vehicleType.per / 100)));
          if (bnu < 0 || !bnu) {
            bnu = 0;
          }
        }
        c.D = this.getCustomClearance();
        if (this.transinsurance) {
          this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
          this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
          this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
          c.CIF = this.insuranceValue;
          c.D = this.getCustomClearance();
          c.T = (c.CIF + this.getCustomClearance()) * 0.83;
          this.finalyTaxPer = 0.83;
          this.taxCalculation = (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount + totalLuxPrice;
          vat = (c.CIF + c.D + this.taxCalculation) * VehicleConstants.PERCENT_VAT;
          this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        else {
          this.finalyTaxPer = 0.83;
          this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.taxCalculation2 = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.insuranceValue = this.getCustomClearancePrice();
          vat = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          c.T = (this.cif2 + this.getCustomClearance()) * 0.83;
          this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }

        if (this.vehicleType?.value?.name == VehicleConstants.ELECTRIC_TYPE_NAME) {
          this.finalTaxMin = this.percentCustomPricesByType();
          //this.finalTaxMin = (totalCustomPrices * (this.vehicleType?.value?.per / 100));
          // Update finalTaxMin if deduct more that percent
          this.updatePurhasedTax();

          this.taxCalculation2 = this.finalTaxMin;

          if (this.transinsurance) {
            // c.CIF => this.insuranceValue => this.getCustomClearancePrice() + this.insTransport
            // c.D => this.getCustomClearance();
            // с.cif2 => this.getCustomClearancePrice()
            // registerFee => 79
            vat = (c.CIF + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          } else {
            this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
            vat = (this.cif2 + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          }
        }
        else if (this.vehicleType?.value?.name == VehicleConstants.PLUGIN_TYPE_NAME) {

          this.finalTaxMin = this.percentCustomPricesByType();
          // Update finalTaxMin if deduct more that percent
          this.updatePurhasedTax();

          this.taxCalculation2 = this.finalTaxMin;
          if (this.transinsurance) {
            vat = (c.CIF + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          } else {
            this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
            vat = (this.cif2 + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
          }
          //totalTaxes = vat + (this.taxCalculation == 0 ? this.taxCalculation2 : this.taxCalculation) + registerFee + c.D;
        }
        else {
          // IF HYBRID, GASOLINE, DIESEL
          this.finalTaxMin = 0;
        }
        //??? when we use it
        this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
        //??? when we use it
        c.CIF = this.cif2;

        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          // discountPer: pollution?.per,
          buyTaxNoDiscount: c.T + totalTaxDiscount,
          buyingTaxPercentage,
          totalLuxPrice,
          effectiveBuyTaxPercent,
          effectiveBuyTax,
          priceNoLux: p0,
          priceWithLux: luxTax,
          finalTax: this.taxCalculation > this.finalTaxMin ? this.taxCalculation : this.finalTaxMin,
          luxTaxPercentage,
          luxTax: totalLuxPrice,
          vat,
          buyTax: c.T,
          totalTaxes,
          customClearance: this.getCustomClearance(),
          value: totalTaxes + this.vehiclePriceILS + (this.vehicleTaxes.shipmentCosts || 0) + customFee + this.value2,
          registerFee,
          customFee,
          reductions,
          shipmentMethod: this.shipmentMethodSelected,
          bnu
        };
        break;
      // Commercial Import
      case 'commercial':
        vehiclePrice = this.vehicleLegitPrice;
        vehicleCurrency = 'ils';
        let vehicleBuyPrice = this.vehiclePrice;
        vehiclePrice = this.convertToIls(vehiclePrice, vehicleCurrency);

        effectiveBuyTax = effectiveBuyTax < bnu ? bnu : effectiveBuyTax;
        this.cif2 = c.CIF;
        const priceMargin = vehiclePrice - 300000;
        vehicleBuyPrice = this.vehiclePriceILS;
        if (this.vehicleWeight && priceMargin > 0) {
          luxTaxPercentage = (priceMargin / vehiclePrice) * 0.2;
        } else {
          luxTaxPercentage = 0;
        }
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        effectiveBuyTax = luxTax + c.T;
        if (vehicleType) {
          bnu = ((c.CIF + c.D) * (luxTaxPercentage + (vehicleType.per / 100))) - reductions.equip;
          if (bnu < 0) {
            bnu = 0;
          }
        }
        c.D = this.getCustomClearance();
        if (this.vehicleWeight) {
          if (this.transinsurance) {
            this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
            this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
            this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
            c.CIF = this.insuranceValue;
            c.D = this.getCustomClearance();
            c.T = (c.CIF + this.getCustomClearance()) * 0.83;
            this.finalyTaxPer = 0.83;
            this.taxCalculation = (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount + totalLuxPrice + luxTax;
            vat = (c.CIF + c.D + this.taxCalculation) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + this.taxCalculation + registerFee + c.D;
          }
          else {
            this.finalyTaxPer = 0.83;
            this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice + luxTax;
            this.taxCalculation2 = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice + luxTax;
            this.insuranceValue = this.getCustomClearancePrice();
            vat = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
            c.T = (this.cif2 + this.getCustomClearance()) * 0.83;
            this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + this.taxCalculation + registerFee + c.D;
          }
          if (this.vehicleType?.value?.name == VehicleConstants.ELECTRIC_TYPE_NAME) { // Electric Type
            this.finalTaxMin = this.percentCustomPricesByType();
            // Update finalTaxMin if deduct more that percent
            this.updatePurhasedTax();

            this.taxCalculation2 = this.finalTaxMin;
            if (this.transinsurance) {
              vat = (c.CIF + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
              this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
              totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
            } else {
              this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice + luxTax;
              vat = (this.cif2 + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
              totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
            }

          } else if (this.vehicleType?.value?.name == VehicleConstants.PLUGIN_TYPE_NAME) { // Plug-in Type

            this.finalTaxMin = this.percentCustomPricesByType();
            console.log('this.finalTaxMin', this.finalTaxMin);
            // Update finalTaxMin if deduct more that percent
            this.updatePurhasedTax();

            this.taxCalculation2 = this.finalTaxMin;
            if (this.transinsurance) {
              vat = (c.CIF + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
              this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
              totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
            } else {
              this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice + luxTax;
              vat = (this.cif2 + c.D + this.finalTaxMin) * VehicleConstants.PERCENT_VAT;
              totalTaxes = vat + this.finalTaxMin + registerFee + c.D;
            }

          } else { // Other Types
            this.finalTaxMin = 0;
          }
        }
        else if (this.finalyTax) {
          reductions.type = 0;
          reductions.equip = 0;
          bnu = 0;
          // totalTaxDiscount = reductions.type + greenDiscount + reductions.equip;
          //this.fullDetails.vehicle = true;//@todo ????????mobile bug
          if (this.transinsurance) {
            this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
            this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
            this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
            c.CIF = this.insuranceValue;
            c.D = this.getCustomClearance();
            c.T = this.taxCalculation;
            this.finalyTaxPer = 1;
            this.taxCalculation = 0;
            vat = (c.CIF + c.D + this.taxCalculation) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + registerFee + c.D;
          }
          else {
            this.finalyTaxPer = 1;
            this.taxCalculation = 0;
            this.taxCalculation2 = 0;
            this.insuranceValue = this.getCustomClearancePrice();
            vat = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
            c.T = this.taxCalculation;
            this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + registerFee + c.D;
          }
          this.finalTaxMin = 0;
        }
        else {
          reductions.type = 0;
          reductions.equip = 0;
          bnu = 0;
          // totalTaxDiscount = reductions.type + greenDiscount + reductions.equip;
          //this.fullDetails.vehicle = true; //@todo ????? mobile bug
          if (this.transinsurance) {
            this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
            this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
            this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
            c.CIF = this.insuranceValue;
            c.D = this.getCustomClearance();
            c.T = (c.CIF + this.getCustomClearance()) * 0.72;
            this.finalyTaxPer = 0.72;
            this.taxCalculation = 0;
            vat = (c.CIF + c.D + this.taxCalculation + c.T) * VehicleConstants.PERCENT_VAT;
            this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
            totalTaxes = vat + c.T + registerFee + c.D;
          }
          else {
            this.finalyTaxPer = 0.72;
            this.taxCalculation = 0;
            this.taxCalculation2 = 0;
            this.insuranceValue = this.getCustomClearancePrice();
            vat = (this.cif2 + c.D + this.taxCalculation + c.T) * VehicleConstants.PERCENT_VAT;
            c.T = (this.cif2 + this.getCustomClearance()) * 0.72;
            this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
            totalTaxes = vat + c.T + registerFee + c.D;
          }
          this.finalTaxMin = 0;
        }
        this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
        c.CIF = this.cif2;


        if (this.consumerVal &&
          this.vehicleForm.valid && !!this.vehicleTaxes && !!this.vehicleLegitPrice && this.vehicleLegitPrice > 0 && this.vehicleTaxes.value > this.vehicleLegitPrice) {
          //this.validatorsPrice = (this.vehicleTaxes.value - this.vehicleLegitPrice).toFixed(0);
          this.consumer = '';
          this.vehicleForm.get('sourceDiscount').patchValue(null);
          this.vehicleForm.get('value').patchValue(null);
          this.sourceDiscount = undefined;
        }

        if (this.high_weight == false && this.transport_ins && this.vehiclePrice && this.sourceValue.value != undefined && this.vehicleCurrency) {
          this.fullDetails.vehicle = true;
        }
        // else {
        //   this.fullDetails.vehicle = this.fullDetails.vehicle && this.vehicleLegitPrice !== undefined && this.equipmentLevelSelected !== undefined;
        // }

        if ((this.vehicleTaxesVal < this.vehicleLegitPrice)) {
          this.vehicleLegitPriceOK = true;
        }
        else if (this.consumerVal) {
          this.vehicleLegitPriceOK = false;
        }

        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          luxTaxPercentage,
          buyingTaxPercentage,
          effectiveBuyTax,
          totalLuxPrice: luxTax,
          vat,
          luxTax,
          totalTaxes,
          registerFee,
          finalTax: this.taxCalculation > this.finalTaxMin ? this.taxCalculation : this.finalTaxMin,
          customClearance: this.getCustomClearance(),
          customFee,
          buyTax: c.T,
          shipmentOnly: this.shipmentOnlyPriceILS,
          reductions,
          value: totalTaxes
            + (this.vehiclePriceILS + this.vehicleTaxes.shipmentCosts || 0) + customFee + this.value2,
          bnu,
          shipmentMethod: this.shipmentMethodSelected,
        };

        break;
      // Commercial taxi
      case 'commercialTaxi':
        reductions.type = 0;
        totalTaxDiscount = greenDiscount + (reductions.equip || 0);
        vehiclePrice = this.vehiclePriceILS;
        vehicleCurrency = this.vehicleCurrency;
        luxTaxPercentage = 0;
        this.cif2 = c.CIF;
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        this.fullDetails.vehicle = this.fullDetails.vehicle && this.equipmentLevelSelected !== undefined;
        c.T = c.CIF * 0.08;
        if (c.T < 0) {
          c.T = 0;
        }
        c.D = this.getCustomClearance();
        if (this.transinsurance) {
          this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
          this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
          this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
          c.CIF = this.insuranceValue;
          c.T = (c.CIF + this.getCustomClearance()) * 0.08;
          c.D = this.getCustomClearance();
          this.finalyTaxPer = 0.08;
          this.taxCalculation = (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount + totalLuxPrice;
          vat = (c.CIF + c.D + this.taxCalculation) * VehicleConstants.PERCENT_VAT;
          this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        else {
          this.finalyTaxPer = 0.08;
          this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.taxCalculation2 = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.insuranceValue = this.getCustomClearancePrice();
          vat = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          c.T = (this.cif2 + this.getCustomClearance()) * 0.08;
          this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        if (
          this.vehicleType?.value?.name == VehicleConstants.HYBRID_TYPE_NAME
          || this.vehicleType?.value?.name == VehicleConstants.PLUGIN_TYPE_NAME
          || this.vehicleType?.value?.label == 'בנזין' //@todo gasoline doest exist in database
        ) {
          this.sourceDiscount = true;
          this.vehicleForm.get('sourceDiscount').patchValue(this.sourceDiscount);
          c.D = 0;
          //this.click_disabled = !this.click_disabled;
          this.click_disabled = true;
          //this.no_discount = false;
        }
        else {
          this.no_discount = true;
          c.D = this.getCustomClearance();
          this.click_disabled = false;
        }
        this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
        c.CIF = this.cif2;
        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          luxTaxPercentage,
          buyingTaxPercentage: 8,
          customClearance: this.getCustomClearance(),
          totalLuxPrice,
          finalTax: this.taxCalculation > 0 ? this.taxCalculation : 0,
          vat,
          totalTaxes,
          registerFee,
          customFee,
          buyTax: c.T,
          reductions,
          shipmentOnly: this.shipmentOnlyPriceILS,
          value: totalTaxes
            + (this.vehiclePriceILS + this.vehicleTaxes.shipmentCosts || 0) + customFee + this.value2,
          bnu: 0,
          shipmentMethod: this.shipmentMethodSelected,

        };
        break;
      // Private taxi
      case 'privateTaxi':
        reductions.type = 0;
        totalTaxDiscount = greenDiscount + (reductions.equip || 0);
        vehiclePrice = this.vehiclePriceILS;
        vehicleCurrency = this.vehicleCurrency;
        luxTaxPercentage = 0;
        c.D = this.getCustomClearance();
        c.T = c.CIF * 0.08;
        this.cif2 = c.CIF;
        luxTax = luxTaxPercentage * (c.CIF + c.D);
        if (this.transinsurance) {
          this.insTransport = (this.cif2 + this.totalTaxes2) * 0.008 < 250 ? 250 : (this.cif2 + this.totalTaxes2) * 0.008;
          this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
          this.insuranceValue = this.getCustomClearancePrice() + this.insTransport;
          c.CIF = this.insuranceValue;
          c.D = this.getCustomClearance();
          c.T = (c.CIF + this.getCustomClearance()) * 0.08;
          this.finalyTaxPer = 0.08;
          this.taxCalculation = (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (c.CIF + c.D)) - totalTaxDiscount + totalLuxPrice;
          vat = (c.CIF + c.D + this.taxCalculation) * VehicleConstants.PERCENT_VAT;
          this.value2 = (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008 < 250 ? 250 : (c.CIF + vat + this.taxCalculation + registerFee + c.D) * 0.008;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        else {
          this.finalyTaxPer = 0.08;
          this.taxCalculation = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.taxCalculation2 = (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount - luxTax < 0 ? 0 : (this.finalyTaxPer * (this.cif2 + c.D)) - totalTaxDiscount + totalLuxPrice;
          this.insuranceValue = this.getCustomClearancePrice();
          vat = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          c.T = (this.cif2 + this.getCustomClearance()) * 0.08;
          this.vat2 = (this.cif2 + c.D + this.taxCalculation2) * VehicleConstants.PERCENT_VAT;
          totalTaxes = vat + this.taxCalculation + registerFee + c.D;
        }
        if (
          this.vehicleType?.value?.name == VehicleConstants.HYBRID_TYPE_NAME
          || this.vehicleType?.value?.name == VehicleConstants.PLUGIN_TYPE_NAME
          || this.vehicleType?.value?.label == 'בנזין' //@todo gasoline doesnt exist in database
        ) {
          this.sourceDiscount = true;
          this.vehicleForm.get('sourceDiscount').patchValue(this.sourceDiscount);
          this.click_disabled = true;
          c.D = 0;
        }
        else {
          this.click_disabled = false;
          this.no_discount = true;
          c.D = this.getCustomClearance();
        }
        this.totalTaxes2 = this.vat2 + this.taxCalculation2 + registerFee + c.D;
        c.CIF = this.cif2;
        this.vehicleTaxes = {
          ...this.vehicleTaxes,
          luxTaxPercentage,
          buyingTaxPercentage: 8,
          shipmentOnly: this.shipmentOnlyPriceILS,
          totalLuxPrice: luxTax,
          vat,
          bnu: 0,
          totalTaxes,
          registerFee,
          customFee,
          customClearance: this.getCustomClearance(),
          buyTax: c.T,
          finalTax: this.taxCalculation > 0 ? this.taxCalculation : 0,
          reductions,
          value: totalTaxes
            + this.vehiclePriceILS + this.vehicleTaxes.shipmentCosts + customFee + this.value2,
          shipmentMethod: this.shipmentMethodSelected,
        };
        break;

      default:
        break;
    }


    return this.vehicleTaxes;
  }

  transportInsurance($event: any) {
    if ($event.value == true) {
      if (this.submitted) {
        this.transport_ins = true;
      }
      else {
        this.transport_ins = false;
      }
      this.transinsurance = true;
    }
    else {
      this.value2 = 0;
      this.transport_ins = true;
      this.transinsurance = false;
    }
    this.calculate();
  }


  vehicleLegitPriceChanged1($event) {
    this.vehicleTaxesVal = this.vehicleTaxes.value;
   // alert(this.vehicleTaxesVal)
   /*
    if ($event.value == null) {
      this.consumer = "";
      this.vehicleLegitPrice = undefined;
    }
    else if (typeof $event === 'number') {
      this.vehicleLegitPrice = $event;
    } else {
      this.vehicleLegitPrice = $event.value != null ? $event.value : parseInt($event.target.value.split(',').join(''));
    }
    */
    //this.vehicleTaxesVal = this.consumer;
    this.vehicleLegitPrice = this.consumer;
    //alert()
    this.calculate();
  }

  vehicleLegitPriceChanged($event) {
    this.vehicleTaxesVal = this.vehicleTaxes.value;
    if ($event.value == null) {
      this.consumer = "";
      this.vehicleLegitPrice = undefined;
    }
    else if (typeof $event === 'number') {
      this.vehicleLegitPrice = $event;
    } else {
      this.vehicleLegitPrice = $event.value != null ? $event.value : parseInt($event.target.value.split(',').join(''));
    }
    this.calculate();
  }
  convertToIls(value: number, currency: string = 'ils') {
    const cur = this.currencies.find(c => c.name === currency);

    if (!cur) {
      return value;
    }

    return value / cur.value;
  }

  sourceDiscountChange($event: any) {
    this.transinsurance = false;
    this.transport_ins = false;
    this.sourceValue = $event;
    this.sourceDiscount = !!$event.value;
    if (this.sourceDiscount == false) {
      this.priceChanged = true;
    }
    else {
      this.priceChanged = false;
    }
    this.vehicleForm.get('sourceDiscount').patchValue(this.sourceDiscount);
    this.vehicleForm.get('insurance').patchValue("");
    this.calculate();
  }

  greenScoreChanged($event) {
    let g = $event.value !== undefined ? $event.value : parseInt($event.target.value.split(',').join(''));
    if (g === '-') {
      this.vehicleForm.get('vehicleAirPollution').setValue(1);
      return;
    }
    if (g <= 0) {
      this.vehicleForm.get('vehicleAirPollution').setValue(1);
    } else if (g >= 400) {
      this.vehicleForm.get('vehicleAirPollution').setValue(15);
      this.vehicleForm.get('greenScore').setValue(400);
    } else {
      g = this.pollutionOptions.find(p => {
        return g >= p.minGreen && g <= p.maxGreen;
      });
      this.vehicleForm.get('vehicleAirPollution').setValue(g.rank);
    }
    this.greenScore = $event.value ? $event.value : parseInt($event.target.value.split(',').join(''));
    this.vehicleAirPollution = g || this.vehicleAirPollution;
    this.calculate();
  }

  updateOrder(isOrder = false) {
    enum IMPORTER {
      Personal = 1,
      Commercial = 2
    }

    let orderRequestData = {
      general: this.generalDetails.value,
      vehicle: { ...this.vehicleForm.value, vehiclePriceILS: this.vehiclePriceILS },
      shipment: this.shipmentDetails.value,
      order: this.orderForm.value,
      taxes: { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS },
      mode: 'update',
      status: isOrder ? 'New' : (this.order.status === 'Temp' ? 'Draft' : this.order.status),
      original: this.order
    };
    if (isOrder)
    {
      if(orderRequestData.order.vehicle.vin == '' || orderRequestData.order.vehicle.details == ''){
        alert('חובת עדכון סוג רכב ומספר שלדה')
        return;
      }
    }
    // api expect number for vehicleType
    if (typeof orderRequestData.vehicle.vehicleType !== 'number') {
      orderRequestData.vehicle.vehicleType = orderRequestData.vehicle.vehicleType?.value?.id;
    }
    // Order cap removed — save orders directly for all importer types (no quota check).
    this.ordersService.updateOrder(orderRequestData).subscribe((res: any) => {
      if (res.code === 200) {
        // const s = !fullDetails.vehicle||!fullDetails.shipment||!fullDetails.terms||orderStatus.inSaving
          this.messageService.add({ severity: 'success', summary: 'עודכן', detail:   ' ההזמנה עודכנה בהצלחה. '});

          if (orderRequestData.status === 'New') {
            setTimeout(() => {
              this.router.navigate(['/account/orders']);
            }, 500);
          }
      } else {
        this.messageService.add({ severity: 'error', summary: 'לא עודכן', detail: 'אירעה שגיאה בעדכון ההזמנה'});
      }
    });


  }

  // New Order Request
  sendOrder(mode: string = 'new') {
    let orderRequestData = {
      order: {
        general: this.generalDetails.value,
        vehicle: { ...this.vehicleForm.value, vehiclePriceILS: this.vehiclePriceILS },
        shipment: this.shipmentDetails.value,
        order: this.orderForm.value,
        taxes: { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS },
        mode
      }
    };
    // api expect number for vehicleType
    if (typeof orderRequestData.order.vehicle.vehicleType !== 'number') {
      orderRequestData.order.vehicle.vehicleType = orderRequestData.order.vehicle.vehicleType?.value?.id;
    }

    this.store.dispatch(createNewOrder(orderRequestData));
  }

  onStepChanged($event: StepperSelectionEvent) {
  }

  shipmentPriceChanged($event: any) {
    this.shipmentPrice = $event.value !== undefined ? $event.value : parseInt($event.target.value.split(',').join(''));
    if(this.shipmentPrice === 0){
      this.selectedCurrency = this.currencies.length > 0 ? this.currencies[0] : null;// this.currencies.shift();
    }
    this.calculate();
  }

  vehicleCurrencyChanged($event: any) {
    this.vehicleForm.get('vehiclePrice').get('buyingPrice').get('currency').setValue($event?.id);
    this.vehicleCurrency = $event;
    this.calculate();
  }

  shipmentMethodChanged($event: any) {
    console.log($event);
    if (!$event) {
      this.shipmentMethodSelected = null;
      this.shipmentCompanyExpanse = null;
      this.shipmentDetails.get('shipmentCompanyExpanse').setValue(this.shipmentCompanyExpanse);
    } else {
      this.shipmentMethodSelected = $event;
      this.shipmentCompanyExpanse = this.shipmentMethodSelected.shipmentCompanyCosts;
      this.shipmentDetails.get('shipmentCompanyExpanse').setValue(this.shipmentCompanyExpanse);
    }
    this.calculate();
  }

  vehicleConditionChanged($event: any) {
    this.vehicleCondition = $event;
    this.calculate();
  }

  vehicleTypeChanged($event: any) {
    this.vehicleType = $event;
    // this.click_disabled = !this.click_disabled;
    if (this.no_discount) {
      this.sourceDiscount = false;
      this.vehicleForm.get('sourceDiscount').patchValue(this.sourceDiscount);
    }
    this.calculate();
  }

  vehicleAirPollutionChanged($event: any) {
    this.vehicleAirPollution = $event;
    this.calculate();
  }

  shipmentCompanyExpanseChanged($event: any) {
    this.shipmentCompanyExpanse = $event.value !== undefined ? $event.value : parseInt($event.target.value.split(',').join(''));
    this.calculate();
  }

  insuranceChanged($event: MatSlideToggleChange) {
    this.transinsurance = $event.checked;
    if (this.transinsurance) {
      this.calculate();
    } else {
      this.totalInsurance = 0;
      this.calculate();
    }
  }

  getInsurance() {
    this.totalInsurance = 0;
    if (this.vehicleTaxes && !this.vehicleTaxes.value) {
      return 0;
    }
    const vehicleValue = this.vehicleTaxes.value;
    this.totalInsurance = vehicleValue * this.insuranceRate;
    return this.totalInsurance;
  }

  importerChanged($event: MatSlideToggleChange) {
    this.imImporter = $event.checked;
    if (this.imImporter) {
      this.orderForm.get('importer').get('name').disable();
      this.orderForm.get('importer').get('phone').disable();
      this.orderForm.get('importer').get('email').disable();
      this.orderForm.get('importer').get('imImporter').setValue(true);

    } else {
      this.orderForm.get('importer').get('name').enable();
      this.orderForm.get('importer').get('phone').enable();
      this.orderForm.get('importer').get('email').enable();
      this.orderForm.get('importer').get('imImporter').setValue(false);
    }
  }

  harborExwRateChanged($event: any) {
    if (!$event) {
      this.selectedExwRate = null;
      this.exwShipmentMethods = null;
      return;
    }
    this.selectedExwRate = $event;
    this.exwShipmentMethods = this.selectedExwRate.ExwShipmentMethods;

  }

  exwShipmentMethodChange($event: any) {
    if ($event) {
      this.exwShipmentMethodSelected = Object.assign({}, $event);
      this.shipmentMethodSelected = $event.ShipmentMethod;
      this.shipmentCompanyExpanse = this.shipmentMethodSelected.shipmentCompanyCosts;
      this.shipmentDetails.get('shipmentType').setValue(this.shipmentMethodSelected.id);
      this.calculate();
    }
  }

  resetExw() {
    this.exwDischargeHarborSelected = null;
    this.selectedHarbor = null;
    this.exwVendorsOptions = null;
    this.exwShipmentMethods = null;
    this.exwHarborsOptions = null;
    this.exwDischargeHarbors = null;
  }

  exwCityChanged($event: any) {
    this.resetExw();
    this.exwCitySelected = $event;
    this.selectedHarbor = null;
    if ($event) {
      this.exwHarborsOptions = $event.options;
    }

  }

  exwDischargeHarborChanged($event: any) {
    this.exwShipmentMethods = null;
    this.shipmentMethodSelected = null;
    this.exwDischargeHarborSelected = $event;
    this.exwVendorsOptions = this.selectedHarbor.exw;
    if (this.exwVendorsOptions.length === 1) {
      this.exwShipmentMethods = this.exwVendorsOptions[0].ExwShipmentMethods;
    }
  }

  exwVendorChange($event: any) {
    this.exwShipmentMethodSelected = null;
    if ($event) {
      this.exwShipmentMethodSelected = $event;
      this.shipmentDetails.get('exwRate').setValue(this.exwShipmentMethodSelected.id);
      this.exwShipmentMethods = $event.ExwShipmentMethods;
      if (this.exwShipmentMethods.length === 1) {
        this.exwShipmentMethodSelected = { ...this.exwShipmentMethods[0] };
        this.shipmentMethodSelected = { ...this.exwShipmentMethods[0] };
        this.shipmentDetails.get('shipmentType').patchValue(this.exwShipmentMethods[0].id);
        this.calculate();
      }
    }
  }

  fcaSourceCountryChanged($event: any) {
    this.selectedFcaSourceCountry = $event;
    this.fcaSourceHarbors = null;
    this.fcaDischargeHarbors = null;
    this.selectedFcaSourceHarbor = null;
    if (!this.selectedFcaSourceCountry) {
      return;
    }
    this.fcaSourceHarbors = this.selectedFcaSourceCountry.sourceHarbors;
  }

  selectedFcaSourceHarborChanged($event: any) {
    this.selectedFcaSourceHarbor = $event;
    if (!this.selectedFcaSourceHarbor) {
      this.selectedFcaDischargeHarbor = null;
      this.fcaSelectedShippingMethod = null;
      this.fcaDischargeHarbors = null;
      return;
    }

    this.fcaDischargeHarbors = this.selectedFcaSourceHarbor.dischargeHarbors;
  }

  selectedFcaDischargeHarborChanged($event: any) {
    this.selectedFcaDischargeHarbor = $event;
    if (!this.selectedFcaDischargeHarbor) {
      this.fcaDeliveryDaysSelected = null;
      this.fcaSelectedShippingMethod = null;
      return;
    }

    this.fcaVendors = this.selectedFcaDischargeHarbor.vendors;

  }

  fcaVendorSelectedChange($event: any) {
    this.fcaSelectedVendor = $event;
    if (!this.fcaSelectedVendor) {
      this.fcaShipmentMethods = null;
      this.fcaSelectedShippingMethod = null;
      return;
    }
    this.fcaDeliveryDaysSelected = $event;
    this.fcaShipmentMethods = this.fcaDeliveryDaysSelected.shipmentMethods;
  }

  fcaShipmentMethodChanged($event: any) {
    if (!$event) {
      this.shipmentDetails.get('fcaRate').setValue(null);
      this.shipmentDetails.get('shipmentType').setValue(null);
      this.fcaShipmentPrice = null;
      this.shipmentMethodSelected = null;
      this.shipmentCompanyExpanse = null;
      return;
    }

    this.fcaShipmentMethodSelected = $event;
    this.shipmentDetails.get('fcaRate').setValue(this.fcaShipmentMethodSelected.FcaRateId);
    this.shipmentDetails.get('shipmentType').setValue(this.fcaShipmentMethodSelected.ShipmentMethod.id);
    this.shipmentMethodSelected = $event.ShipmentMethod;
    this.fcaShipmentPrice = $event.price;
    this.shipmentCompanyExpanse = this.shipmentMethodSelected.shipmentCompanyCosts;
  }

  fcaPriceChanged($event: any) {
    if (!$event) {
      return;
    }
    if(this.shipmentPrice == 0){
      this.selectedCurrency = this.currencies.length > 0 ? this.currencies[0] : null;
    }

    if (typeof $event === 'number') {
      this.shipmentPrice = $event;
    } else {
      this.shipmentPrice = $event.value !== undefined ? $event.value : parseInt($event.target.value.split(',').join(''));
    }
    this.calculate();
  }

  showMobileCalculation() {
    let sheetRef;
    let vehicleObj = { ...this.vehicleForm.value, vehiclePriceILS: this.vehiclePriceILS };
    let taxesObj = { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS };
    let generalObj = this.generalDetails.value;
    delete vehicleObj.greenScoreValid;
    delete generalObj.importerType;
    vehicleObj.vehicleCondition = this.vehicleCondition.value.id;

    // api expect number for vehicleType
    if (typeof vehicleObj.vehicleType !== 'number') {
      vehicleObj.vehicleType = vehicleObj.vehicleType?.value?.id;
    }

    if (this.personalBroker) {
      delete taxesObj.shipmentOnly;
      taxesObj.buyTaxNoDiscount;
      taxesObj.effectiveBuyTax = this.taxCalculation > 0 ? this.taxCalculation : this.finalTaxMin;
      taxesObj.effectiveBuyTaxPercent;
      taxesObj.luxTax;
      taxesObj.priceNoLux;
      taxesObj.priceWithLux;
    }

    this.ordersService.updateOrder({
      general: generalObj,
      vehicle: vehicleObj,
      shipment: this.shipmentDetails.value,
      order: { ...this.orderForm.value, terms: true },
      taxes: taxesObj,
      original: this.order,
      mode: 'new',
    }).subscribe((res: any) => {
      this.order = res.data;
      sheetRef = this._bottomSheet.open(CalculationMobileComponent, {
        hasBackdrop: true,
        data: {
          taxes: this.vehicleTaxes,
          customClearance: this.nameType,
          order: this.orderForm.value,
          general: this.generalDetails.value,
          shipment: this.shipmentDetails.value,
          shipmentOnlyIls: this.shipmentOnlyPriceILS,
          sellingType: this.selectedSellingType,
          harborTaxes: this.harborTaxesForCalculate,
          vehiclePriceILS: this.vehiclePriceILS,
          vehiclePrice: this.vehiclePrice,
          vehicleCurrency: this.vehicleCurrency,
          vehiclePollution: this.vehicleAirPollution,
          vehicleType: this.vehicleType,
          customClearanceVal: this.getCustomClearance(),
          customClearancePrice: this.getCustomClearancePrice(),
          terms: true,
          Order: this.order,
          equipmentLevelSelected: this.equipmentLevelSelected,
          nameType: this.nameType,
          greenScore: this.greenScore,
          transinsurance: this.transinsurance,
          value2: this.value2,
          insTransport: this.insTransport,
          insuranceValue: this.insuranceValue,
          vehicleWeight: this.vehicleWeight,
          personalBroker: this.personalBroker,
        }
      });
    });
  }

  // customClearance: this.selectionType,
  checkIsFullDetails() {
  }
  share(type: string) {
    if (this.order.status === 'Temp') {
      // let taxesObj = { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS };
      let generalObj = this.generalDetails.value;
      let vehicleObj = { ...this.vehicleForm.value, vehiclePriceILS: this.vehiclePriceILS };
      // delete taxesObj.effectiveBuyTax;
      // delete taxesObj.luxTax;
      delete generalObj.importerType;

      // api expect number for vehicleType
      if (typeof vehicleObj.vehicleType !== 'number') {
        vehicleObj.vehicleType = vehicleObj.vehicleType?.value?.id;
      }

      this.ordersService.updateOrder(
        {
          general: generalObj,
          vehicle: vehicleObj,
          shipment: this.shipmentDetails.value,
          order: { ...this.orderForm.value, terms: true },
          taxes: { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS },
          original: this.order,
          status: 'Draft',
          mode: 'new'
        }
      ).subscribe((res: any) => {
        if (res.code === 200) {
          this.order = { ...res.data };
          this.order.status = 'Draft';
        }
        // debugger
        this.shareByPlatform(type);
      });
    } else {
      let generalObj = this.generalDetails.value;
      let vehicleObj = { ...this.vehicleForm.value, vehiclePriceILS: this.vehiclePriceILS };
      delete generalObj.importerType;

      //vehicleObj.vehicleType = this.vehicleType.value.id;
      // api expect number for vehicleType
      if (typeof vehicleObj.vehicleType !== 'number') {
        vehicleObj.vehicleType = vehicleObj.vehicleType?.value?.id;
      }

      this.ordersService.updateOrder(
        {
          general: generalObj,
          vehicle: vehicleObj,
          shipment: this.shipmentDetails.value,
          order: { ...this.orderForm.value, terms: true },
          taxes: { ...this.vehicleTaxes, shipmentOnlyIls: this.shipmentOnlyPriceILS },
          original: this.order,
          status: 'Draft',
          mode: 'new'
        }).subscribe((res: any) => {
          this.order = { ...res.data };
          this.shareByPlatform(type);
        });
    }
  }

  shareByPlatform(platform: string) {
    switch (platform) {
      case 'print':
        window.open(this.shareUrl + 'pdf/' + this.order.slug.slug + '?print=true');
        break;
      case 'whatsapp':
        window.open(`https://wa.me?text=${encodeURIComponent(`מצורף תחשיב משוער ליבוא (${this.order.title || 'הזמנה מספר ' + this.order.id})`)} \n` + this.shareUrl + 'pdf/' + this.order.slug.slug);
        break;
      case 'savePdf':
        this.ordersService.exportOrderToPdf(this.order).subscribe(res => {
          let blob = new Blob([res], { type: 'application/pdf' });
          // const fileURL = URL.createObjectURL(blob);
          // window.open(fileURL, '_blank');
          saveAs(blob, `order-${this.order.id}.pdf`);
        });
        break;
      case 'email':
        window.open(`mailto:?subject=מצורף תחשיב משוער ליבוא (${this.order.title || 'הזמנה מספר ' + this.order.id})&body=${encodeURI(this.shareUrl + 'pdf/' + this.order.slug.slug)}`);
        break;
    }
  }

  openDocumentsModal() {
    this.sideVisible = false;
    const ref = this.dialog.open(AddDocumentsModalComponent, {
      data:
        { order: this.order, fileTypes: this.fileTypes }
    });
    ref.componentInstance.onUpload.subscribe(d => {
      if (d) {

        this.updateOrder(false);
      }
    });
    ref.afterClosed().subscribe(c => {
      this.sideVisible = true;
    });
  }

  onTaxYearChanged($event: any) {
    this.updateVehicleTypes($event.types);
  }

  /**
   * If sum of custom prices minus discounts higher than electric/plugin percent from this sum
   * then rewrite finalTaxMin and display it on "Coordinated purchase tax"
   * only for Electric/Plug-in
   * @private
   */
  private updatePurhasedTax(): void {
    if( this.taxCalculation > 0 && this.taxCalculation > this.finalTaxMin ){
      this.finalTaxMin = this.taxCalculation;
    }
  }

  /**
   * get vehicle type percent of sum custom prices
   * only for Electric/Plug-in
   * @private
   */
  private percentCustomPricesByType(): number {
    console.log('percentCustomPricesByType');
    console.log(this.vehicleType);
    console.log('percentCustomPricesByType end');
    const per = this.vehicleType?.value?.per || this.vehicleType?.value?.taxPercentage;
    return ((this.insuranceValue + this.getCustomClearance()) * (per / 100));
  }

  ngOnDestroy(): void {
    if (this.langSub) { this.langSub.unsubscribe(); }
  }
}
